import Vue from "vue";
import VueRouter from "vue-router";

import configObject from "@/config";

// Accounts
const Login = () => import("../views/Customer/Login");
const Signup = () => import("../views/Customer/signup");
const Resolver = () => import("../views/Customer/Resolver");
const RegistrationCompleted = () =>
  import("../views/Customer/RegistrationCompleted");
const Account_confrimation_login = () =>
  import("../views/Customer/Account_confrimation_login");
const ResetPassword = () => import("../views/Customer/Reset_password");
const PasswordResetConfirmation = () =>
  import("../views/Customer/Password_reset_confirmation");
const PasswordEmailNotification = () =>
  import("../views/Customer/Password_email_notification");

// CUSTOMER VIEWS
const DriversVehicles = () =>
  import("../views/Customer/drivers/driversVehicles");
const DashboardIndex = () => import("../views/Customer/dashboard/index");
const FuelBalance = () => import("../views/Customer/FuelBalance/FuelBalance");
const ExtendedReport = () => import("../views/Customer/extended_report");
const Voucher = () => import("../views/Customer/voucher/Voucher");
const Driver = () => import("../views/Customer/drivers/index");
const PreviousWalletTransaction = () =>
  import("../views/Customer/FuelBalance/PreviousWalletTransaction");
const Vehicle = () => import("../views/Customer/Vehicle/index");
const LinkedVehicle = () => import("../views/Customer/Vehicle/linkedVehicle");
const Create_vehicle = () => import("../views/Customer/Vehicle/create_vehicle");
const CardInformation = () =>
  import("../views/Customer/Vehicle/cardInformation");
const FundCard = () => import("../views/Customer/Vehicle/fundCard.vue");
const VerifyReceipt = () => import("../views/Customer/verify_receipt/index");
const FuelConsumption = () => import("../views/Customer/fuelConsumption/index");
const VehicleFuelConsumption = () =>
  import("../views/Customer/fuelConsumption/vehicle_fuel_consumption");
const Retainership = () => import("../views/Customer/Retainership/index");
const QuickFuel = () => import("../views/Customer/Quick_fuel/index");
const CreateVoucher = () => import("../views/Customer/voucher/createVoucher");
const SendVoucher = () => import("../views/Customer/SendVoucher/index");
const SendConfirmedVouchers = () =>
  import("../views/Customer/Vehicle/sendConfirmedVouchers");
const SubAccounts = () => import("../views/Customer/sub_accounts/index");
const Create_sub_account = () =>
  import("../views/Customer/sub_accounts/create_sub_account");
const Sub_account_details = () =>
  import("../views/Customer/sub_accounts/sub_account_details");
const Profile = () => import("../views/Customer/Profile/index");
const FundWallet = () => import("../views/Customer/Fund_wallet/index");
const OutstandingPaymentsList = () =>
  import("../views/Customer/outstanding_payments/index");
const OutstandingPayments = () =>
  import("../views/Customer/outstanding_payments/outstanding_payments");
const WalletTransactions = () =>
  import("../views/Customer/outstanding_payments/walletTransactions");
const Cards = () => import("../views/Customer/Cards/index");
const VehicleCards = () => import("../views/Customer/Vehicle/VehicleCards");

// DEALER VIEWS
const Dealer = () => import("../views/Dealer/Dashboard/index");
const DealerProfile = () => import("../views/Dealer/Profile/index");
const DealerBranches = () => import("../views/Dealer/Our_branches/index");
const DealerPriceManagement = () =>
  import("../views/Dealer/price_management/index");
const DealerSales = () => import("../views/Dealer/sales/index");
const DealerVarianceReport = () =>
  import("../views/Dealer/variance_report/index");
const DealerTankVariance = () =>
  import("../views/Dealer/variance_report/dealerTankVariance");
const DealerTanksFilled = () => import("../views/Dealer/tanks_filled/index");
// const DealerCashFlow = () => import("../views/Dealer/CashFlow/index");
const DealerTankStock = () => import("../views/Dealer/TankStock/index");
const DealerBranchSales = () => import("../views/Dealer/BranchSales/index");
const DealerProductsFilled = () =>
  import("../views/Dealer/Product_fills/index");
const DealerProductValuation = () => import("../views/Dealer/ProductValuation");
const DailyDealerBranchTrans = () =>
  import("../views/Dealer/Reports/dailyBranchTrans");
const DealerBranchesReport = () =>
  import("../views/Dealer/Reports/dealerBranchesReport");
const sendDealerReport = () => import("../views/Dealer/Reports/sendReport");
const DealerDisconnectedPumps = () =>
  import("../views/Dealer/Dashboard/disconnected");
const DealerOfflinePumps = () => import("../views/Dealer/Dashboard/offline");
// const DealerShutdownHistory = () => import("../views/Dealer/shutdownHistory");
const DealerPumpsHistory = () =>
  import("../views/Dealer/Dashboard/disconnected_pumps_history");
const DealerExpenses = () =>
  import("../views/Dealer/Manage_Expenses/dealer_expenses");
const DealerBranchesExpenses = () =>
  import("../views/Dealer/Manage_Expenses/branchesExpenses");
const DealerBranchesExpenseBreakdown = () =>
  import("../views/Dealer/Manage_Expenses/dealerBranchExpensesBreakdown");
const DealerExpensesCategories = () =>
  import("../views/Dealer/Manage_Expenses/expenses_categories");
const DealerAggregatedFaults = () =>
  import("../views/Dealer/Aggregated_company_faults/aggregatedFaults");
const DealerMaintenanceList = () =>
  import("../views/Dealer/Maintenance/maintenanceList");

// GROUP VIEWS
const Group = () => import("../views/groupManagement/Dashboard/index");
const GroupProfile = () => import("../views/groupManagement/Profile/index");
const GroupBranches = () =>
  import("../views/groupManagement/Our_branches/index");
const GroupSales = () => import("../views/groupManagement/sales/index");
const GroupBranchSales = () =>
  import("../views/groupManagement/BranchSales/index");
const GroupVarianceReport = () =>
  import("../views/groupManagement/variance_report/index");
const GroupTankVariance = () =>
  import("../views/groupManagement/variance_report/groupTankVariance");
const GroupTanksFilled = () =>
  import("../views/groupManagement/tanks_filled/index");
const GroupCashFlow = () => import("../views/groupManagement/CashFlow/index");
const GroupTankStock = () => import("../views/groupManagement/TankStock/index");
const GroupProductsFilled = () =>
  import("../views/groupManagement/Product_fills/index");
const GroupProductValuation = () =>
  import("../views/groupManagement/ProductValuation");
const GroupServices = () =>
  import("../views/groupManagement/Services/services");
const GroupServicesTransactions = () =>
  import("../views/groupManagement/Services/transactions");
const GroupLease = () => import("../views/groupManagement/Lease/index");
const GroupServiceTransactions = () =>
  import("../views/groupManagement/Services/serviceTransactions");
const GroupNonWetProductSupply = () =>
  import("../views/groupManagement/dry-stock/supply");
const GroupNonWetProductsSales = () =>
  import("../views/groupManagement/dry-stock/sales");
const GroupProductStock = () =>
  import("../views/groupManagement/dry-stock/groupProductStock");
const GroupProductStockDetails = () =>
  import("../views/groupManagement/dry-stock/productStockDetails");
const GroupSupplyHistory = () =>
  import("../views/groupManagement/dry-stock/suppliesHistory");
const GroupSalesHistory = () =>
  import("../views/groupManagement/dry-stock/salesHistory");
const GroupsalesDetails = () =>
  import("../views/groupManagement/dry-stock/salesDetails");
const GroupsupplyDetails = () =>
  import("../views/groupManagement/dry-stock/supplyDetails");
const GroupBankLinkedTransactions = () =>
  import("../views/groupManagement/Manage_Expenses/bankLinkedTransactions");
const GroupLiveBankTransactions = () =>
  import("../views/groupManagement/Manage_Expenses/liveBankTransactions");
const GroupLiveBankTransactionsBreakdown = () =>
  import(
    "../views/groupManagement/Manage_Expenses/liveBankTransactionsBreakdown"
  );
const GroupPOS = () => import("../views/groupManagement/POS/index");
const GroupPosTerminals = () =>
  import("../views/groupManagement/POS/posTerminals");
const GroupPosTerminalsDetails = () =>
  import("../views/groupManagement/POS/terminalDetails");
const GroupAggregatedFaults = () =>
  import("../views/groupManagement/Aggregated_company_faults/aggregatedFaults");
const GroupMaintenanceList = () =>
  import("../views/groupManagement/Maintenance/maintenanceList");
const GroupPriceManagement = () =>
  import("../views/groupManagement/price_management/index");
const GroupPriceApproval = () =>
  import("../views/groupManagement/price_management/approvePrice");
const GroupPriceManagers = () =>
  import("../views/groupManagement/price_management/priceManagers");
const GroupBranchCluster = () =>
  import("../views/groupManagement/price_management/branchCluster");
const GroupPriceManagementLog = () =>
  import("../views/groupManagement/price_management/priceLog");
const GroupPumpCalibrationLogs = () =>
  import("../views/groupManagement/pump_calibration_logs/index");
const GroupWallet = () => import("../views/groupManagement/Group_wallet/index");

// REGION VIEWS
const Region = () => import("../views/RegionalManager/Dashboard/index");
const RegionProfile = () => import("../views/RegionalManager/Profile/index");
const RegionBranches = () =>
  import("../views/RegionalManager/Our_branches/index");
const RegionSales = () => import("../views/RegionalManager/sales/index");
const RegionBranchSales = () =>
  import("../views/RegionalManager/BranchSales/index");
const RegionVarianceReport = () =>
  import("../views/RegionalManager/variance_report/index");
const RegionTankVariance = () =>
  import("../views/RegionalManager/variance_report/regionTankVariance");
const RegionTanksFilled = () =>
  import("../views/RegionalManager/tanks_filled/index");
const RegionCashFlow = () => import("../views/RegionalManager/CashFlow/index");
const RegionTankStock = () =>
  import("../views/RegionalManager/TankStock/index");
const RegionProductsFilled = () =>
  import("../views/RegionalManager/Product_fills/index");
const RegionProductValuation = () =>
  import("../views/RegionalManager/ProductValuation");
// const DailyRegionBranchTrans = () =>
//   import("../views/RegionalManager/Reports/dailyBranchTrans");
// const DealerBranchesReport = () =>
//   import("../views/Dealer/Reports/dealerBranchesReport");
// const sendDealerReport = () => import("../views/Dealer/Reports/sendReport");
const RegionServices = () =>
  import("../views/RegionalManager/Services/services");
const RegionServiceTransactionDetails = () =>
  import("../views/RegionalManager/Services/serviceTransactionDetails");
const RegionServicesTransactions = () =>
  import("../views/RegionalManager/Services/transactions");
const RegionLease = () => import("../views/RegionalManager/Lease/index");
const RegionServiceTransactions = () =>
  import("../views/RegionalManager/Services/serviceTransactions");
const RegionNonWetProductSupply = () =>
  import("../views/RegionalManager/dry-stock/supply");
const RegionNonWetProductsSales = () =>
  import("../views/RegionalManager/dry-stock/sales");
const RegionProductStock = () =>
  import("../views/RegionalManager/dry-stock/regionProductStock");
const RegionProductStockDetails = () =>
  import("../views/RegionalManager/dry-stock/productStockDetails");
const RegionSupplyHistory = () =>
  import("../views/RegionalManager/dry-stock/suppliesHistory");
const RegionSalesHistory = () =>
  import("../views/RegionalManager/dry-stock/salesHistory");
const RegionsalesDetails = () =>
  import("../views/RegionalManager/dry-stock/salesDetails");
const RegionsupplyDetails = () =>
  import("../views/RegionalManager/dry-stock/supplyDetails");
const RegionBankLinkedTransactions = () =>
  import("../views/RegionalManager/Manage_Expenses/bankLinkedTransactions");
const RegionLiveBankTransactions = () =>
  import("../views/RegionalManager/Manage_Expenses/liveBankTransactions");
const RegionLiveBankTransactionsBreakdown = () =>
  import(
    "../views/RegionalManager/Manage_Expenses/liveBankTransactionsBreakdown"
  );
const RegionPOS = () => import("../views/RegionalManager/POS/index");
const RegionPosTerminals = () =>
  import("../views/RegionalManager/POS/posTerminals");
const RegionPosTerminalsDetails = () =>
  import("../views/RegionalManager/POS/terminalDetails");
const RegionAggregatedFaults = () =>
  import("../views/RegionalManager/Aggregated_company_faults/aggregatedFaults");
const RegionMaintenanceList = () =>
  import("../views/RegionalManager/Maintenance/maintenanceList");

// COMPANY VIEWS
const Company = () => import("../views/Company/Dashboard/index");
const AggregatedFaults = () =>
  import("../views/Company/Aggregated_company_faults/aggregatedFaults");
const MaintenanceList = () =>
  import("../views/Company/Maintenance/maintenanceList");
const Waybill = () => import("../views/Company/Waybill/waybill");
const TrucksAndDrivers = () =>
  import("../views/Company/TrucksAndDrivers/index");
const AlertAlarm = () => import("../views/Company/AlertAlarm/alertAlarm");
const MakePayment = () => import("../views/Company/MakePayment/index");
const MakePaymentStripe = () =>
  import("../views/Company/MakePayment/indexStripe");
const CompanyGroup = () => import("../views/Company/GroupManagement/index");
const CompanyRegion = () => import("../views/Company/RegionalManager/index");
const OfflinePumps = () => import("../views/Company/Dashboard/offline");
const DisconnectedPumps = () =>
  import("../views/Company/Dashboard/disconnected");
const CompanySufficiency = () => import("../views/Company/CompanySufficiency");
const OurBranches = () => import("../views/Company/Our_branches/index");
const OurDealers = () => import("../views/Company/Our_dealers/index");
const FundWalletRequest = () =>
  import("../views/Company/Fund_wallet_request/index");
const CompanyRetainership = () => import("../views/Company/Retainership/index");

const AllCards = () => import("../views/Company/Remis/allCards");
const CompanyRetainershipSales = () =>
  import("../views/Company/Retainership/sales");
const RetainershipWalletTransactions = () =>
  import("../views/Company/Retainership/walletTransactions");

const AllRetainersWalletTransactions = () =>
  import("../views/Company/Remis/allWalletTransactions.vue");

const DealerDetails = () => import("../views/Company/dealer_details/index");
const MailReceipt = () => import("../views/Company/mail_receipt/index");
const CompanyProfile = () => import("../views/Company/Profile/index");
const TanksFilled = () => import("../views/Company/tanks_filled/index");
const TransactionCount = () =>
  import("../views/Company/TransactionCount/index");
const ProductFills = () => import("../views/Company/Product_fills/index");
const ProductReceived = () => import("../views/Company/Product_received/index");
const BranchTanksFilled = () => import("../views/Branch/tanks_filled/index");
const ManageExpenses = () => import("../views/Company/Manage_Expenses/index");
const CompanyExpenses = () =>
  import("../views/Company/Manage_Expenses/company_expenses");
const CompanyAccounts = () =>
  import("../views/Company/Manage_Expenses/bank_accounts");
const ExpensesCategories = () =>
  import("../views/Company/Manage_Expenses/expenses_categories");
const CompanyBranchesExpenses = () =>
  import("../views/Company/Manage_Expenses/branchesExpenses");
const CompanyBranchesExpenseBreakdown = () =>
  import("../views/Company/Manage_Expenses/companyBranchExpensesBreakdown");
const Zones = () => import("../views/Company/Zones/index");
const Assets = () => import("../views/Company/Assets/index");
const ViewAssetsGroups = () => import("../views/Company/Assets/viewGroup");
const AssignBranches = () => import("../views/Company/Zones/assignbranch");
const ZoneBranches = () => import("../views/Company/Zones/zonebranch");
const CompanySales = () => import("../views/Company/sales/index");
const CompanyTotalSales = () => import("../views/Company/sales/index");
const PriceManagement = () => import("../views/Company/price_management/index");
const PriceManagementLog = () =>
  import("../views/Company/price_management/priceLog");
const ApprovePrice = () =>
  import("../views/Company/price_management/approvePrice");
const BranchCluster = () =>
  import("../views/Company/price_management/branchCluster");
const PriceManagers = () =>
  import("../views/Company/price_management/priceManagers");
const PumpCalibrationLogs = () =>
  import("../views/Company/pump_calibration_logs/index");
const ManageDrivers = () => import("../views/Company/Driver/manage_drivers");
const ManageTrucks = () => import("../views/Company/Driver/manage_trucks");
const DeliverableProducts = () => import("../views/Company/Product/index");
const ProductLGA = () => import("../views/Company/Product/productLGA");
const AddProduct = () => import("../views/Company/Product/addProduct");
const AssignTruck = () => import("../views/Company/Driver/assign_truck");
const AssignedTruck = () => import("../views/Company/Driver/assigned_truck");
const AssignedOrders = () => import("../views/Company/Driver/assigned_orders");
const ManageOrders = () => import("../views/Company/Order/manage_orders");
const CreateOrder = () => import("../views/Company/Order/add_order");
const EditOrder = () => import("../views/Company/Order/editOrder");
const AssignDriverToOrder = () =>
  import("../views/Company/Order/assign_driver");
const CompanyVarianceReport = () => import("../views/Company/variance_report/");
const companyTankVariance = () =>
  import("../views/Company/variance_report/companyTankVariance");
const RegionSalesReport = () => import("../views/Company/RegionSales");
const CompanyOutstandingPaymentsList = () =>
  import("../views/Company/outstanding_payments/index");
const CompanyOutstandingPayments = () =>
  import("../views/Company/outstanding_payments/outstanding_payments");
const CompanyWalletTransactions = () =>
  import("../views/Company/outstanding_payments/walletTransactions");
const CompanyPOS = () => import("../views/Company/POS/index");
const CompanyCashFlow = () => import("../views/Company/CashFlow/index");
const Invoices = () => import("../views/Company/Invoices/index");
const InvoiceDetails = () => import("../views/Company/Invoices/invoiceDetails");
const InvoicePayments = () =>
  import("../views/Company/Invoices/invoicePayment");
const SuccessPage = () => import("../views/Company/Invoices/successPage");
const NotFound = () => import("../views/NotFound.vue");
const CompanyUsers = () => import("../views/Company/Users/index");
const BranchUsers = () => import("../views/Branch/Branch_Users/index");
const CreateUser = () => import("../views/Company/Users/createUser");
const UserDetails = () => import("../views/Company/Users/userDetails");
const AddUserToRole = () => import("../views/Company/Users/addUserToRole");
const CompanyWallet = () => import("../views/Company/Wallets/companyWallet");
const CompanyWallets = () => import("../views/Company/Wallets/index");
const CompanyWalletTopUp = () => import("../views/Company/Wallets/topUp");
const CompanyTransactions = () =>
  import("../views/Company/BranchWalletTransaction");
const DisconnectedPumpHistory = () =>
  import("../views/Company/Dashboard/disconnected_pumps_history");
const Loyalty = () => import("../views/Company/Loyalty/index");
const LoyaltyDetails = () =>
  import("../views/Company/Loyalty/programDetails.vue");
const TankStock = () => import("../views/Company/TankStock/index");
const CompanyBranchSales = () => import("../views/Company/BranchSales/index");
const CompanyTankSales = () => import("../views/Company/TankSales/index");
const CompanyProductFillsDetails = () =>
  import("../views/Company/Product_fills/productFillsBreakdown");
const CompanyProductValuation = () =>
  import("../views/Company/ProductValuation");
const PosTerminals = () => import("../views/Company/POS/posTerminals");
const PosTerminalsDetails = () =>
  import("../views/Company/POS/terminalDetails");
const SetRecurring = () => import("../views/Company/Invoices/setRecurring");
const LinkBankAccounts = () =>
  import("../views/Company/BankAccounts/linkBankAccounts");
const LinkCompanyBankAccounts = () =>
  import("../views/Company/Manage_Expenses/linkBankAccounts");
const RecurringBreakdown = () =>
  import("../views/Company/Invoices/recurringBreakdown");
const RecurringPaymentStatusPage = () =>
  import("../views/Company/Invoices/successPage");
const SubscriptionTransactions = () =>
  import("../views/Company/Invoices/subscriptionTransactions");
const SubscriptionsTransactionsBreakdown = () =>
  import("../views/Company/Invoices/subscriptionsTransactionsBreakdown");
const BankLinkedTransactions = () =>
  import("../views/Company/Manage_Expenses/bankLinkedTransactions");
const LiveBankTransactions = () =>
  import("../views/Company/Manage_Expenses/liveBankTransactions");
const LiveBankTransactionsBreakdown = () =>
  import("../views/Company/Manage_Expenses/liveBankTransactionsBreakdown");
const MapUserToRole = () => import("../views/Company/Users/mapUserToRole");
const shutdownHistory = () => import("../views/Company/shutdownHistory");
const CompanyBranchesReport = () =>
  import("../views/Company/Reports/companyBranchesReport");
const DailyBranchTrans = () =>
  import("../views/Company/Reports/dailyBranchTrans");
const sendReport = () => import("../views/Company/Reports/sendReport");
const NonWetProductsSales = () => import("../views/Company/dry-stock/sales");
const NonWetProducts = () => import("../views/Company/dry-stock/products");
const CreateNonWetProduct = () =>
  import("../views/Company/dry-stock/createNonWetProduct");
const NonWetProductsCategories = () =>
  import("../views/Company/dry-stock/categories");
const CreateNonWetProductsCategories = () =>
  import("../views/Company/dry-stock/createCategories");
const NonWetProductSupply = () => import("../views/Company/dry-stock/supply");
const CreateNonWetProductSupply = () =>
  import("../views/Company/dry-stock/createSupply");
const salesBreakdown = () =>
  import("../views/Company/dry-stock/salesBreakdown");
const BranchProductStock = () =>
  import("../views/Company/dry-stock/branchProductStock");
const salesDetails = () => import("../views/Company/dry-stock/salesDetails");
const supplyDetails = () => import("../views/Company/dry-stock/supplyDetails");
const SupplyHistory = () =>
  import("../views/Company/dry-stock/suppliesHistory");
const SalesHistory = () => import("../views/Company/dry-stock/salesHistory");
const CompanyServices = () => import("../views/Company/Services/services");
const CompanyServicesTransactions = () =>
  import("../views/Company/Services/transactions");
const AddService = () => import("../views/Company/Services/addService");
const CompanyLease = () => import("../views/Company/Lease/index");

const CompanyCreateLease = () => import("../views/Company/Lease/createLease");
const CompanyBranchSpace = () => import("../views/Company/Lease/branchSpace");
const CreateCompanyBranchSpace = () =>
  import("../views/Company/Lease/createBranchSpace");
const ServiceTransactions = () =>
  import("../views/Company/Services/serviceTransactions");
const CompanyBranchLeases = () => import("../views/Company/Lease/branchLeases");
const ProductStockDetails = () =>
  import("../views/Company/dry-stock/productStockDetails");
const ServiceTransactionDetails = () =>
  import("../views/Company/Services/serviceTransactionDetails");
const BankAcctRequest = () => import("../views/Company/BankAcctRequest");
const RemisRetainership = () => import("../views/Company/Remis/retainership");
const RetainerDetails = () => import("../views/Company/Remis/retainerDetails");
const CardTransactions = () =>
  import("../views/Company/Remis/CardTransactions");
const RetainershipCardRequest = () =>
  import("../views/Company/Remis/cardRequest");
const ApproveRetainershipCardRequest = () =>
  import("../views/Company/Remis/approveCardRequest");
const CompanyEsales = () => import("../views/Company/Esales/index");
const CompanyEsalesWallet = () =>
  import("../views/Company/Esales/companyWallet");
const CompanyEsalesRemis = () => import("../views/Company/Esales/remisSales");
const RoleManagement = () => import("../views/Company/RoleManagement/index");
const MapRoles = () => import("../views/Company/RoleManagement/mapRoles");

// BRANCH ROUTES
const BranchDashboard = () => import("../views/Branch/Dashboard/index");
const BranchBankAcctRequest = () =>
  import("../views/Branch/BranchBankAcctRequest");
const BranchSettlementTransactions = () =>
  import("../views/Branch/BranchSettlementTransaction");
const BranchSufficiency = () => import("../views/Branch/BranchSufficiency");
const BranchTransactions = () => import("../views/Branch/WalletTransaction");
const AverageTimePerLitre = () =>
  import("../views/Branch/Dashboard/pumps_average_time_per_litre");
const BranchDisconnectedPumps = () =>
  import("../views/Branch/Dashboard/disconnected");
const BranchOfflinePumps = () => import("../views/Branch/Dashboard/offline");
const PumpsCalibration = () =>
  import("../views/Branch/Dashboard/pumps_calibration");
const VarianceReport = () => import("../views/Branch/varianceReport/index");
const PumpTankReport = () =>
  import("../views/Branch/varianceReport/pumpTankReport");
const BranchSalesTransactions = () =>
  import("../views/Branch/salesTransactions/index");
const EndOfTheDayReport = () =>
  import("../views/Branch/End_of_the_day_report/index");
const TankReports = () => import("../views/Branch/Tank_report/index");
const Tanks = () => import("../views/Branch/Tanks/index");
const TankDetails = () => import("../views/Branch/Tanks/details");
const ProbeTransaction = () =>
  import("../views/Branch/Tanks/probe_transaction");
const DailyReport = () => import("../views/Branch/Tanks/daily_report");
const Pumps = () => import("../views/Branch/Pumps/index");
const RecordPumpsFaults = () =>
  import("../views/Branch/Pumps/record_faults.vue");
const PumpsMaintenance = () =>
  import("../views/Branch/Pumps/pumps_maintenance");
const FaultsMaintenance = () => import("../views/Branch/Faults/index");
const Maintenance = () => import("../views/Branch/Faults/Maintenance/index");
const PumpTransactions = () =>
  import("../views/Branch/Pumps/pump__transactions");
const PumpDetails = () => import("../views/Branch/Pumps/pump__details.vue");
const BranchWallet = () => import("../views/Branch/Branch_wallet/index");
const SettlementAccount = () =>
  import("../views/Branch/settlement_account/index");
const Staff = () => import("../views/Branch/People_management/staff");
const EditStaff = () => import("../views/Branch/People_management/edit_staff");
const StaffDetails = () =>
  import("../views/Branch/People_management/view_staff");
const NewStaff = () => import("../views/Branch/People_management/newStaff");
const Shift = () => import("../views/Branch/People_management/shift");
const ShiftAssignments = () =>
  import("../views/Branch/People_management/shift_assignments");
const ShiftDeposits = () =>
  import("../views/Branch/People_management/shift_deposits");
const Expenses = () => import("../views/Branch/Accounting/expenses");
const Targets = () => import("../views/Branch/Targets/index.vue");
const BankAccounts = () => import("../views/Branch/Accounting/bank_accounts");
const UpdatePrice = () =>
  import("../views/Branch/Station_Management/update_price");
const ManagePrice = () =>
  import("../views/Branch/Station_Management/manage_price");
const BranchApprovePrice = () =>
  import("../views/Branch/Station_Management/approvePrice");
const BranchPriceManager = () =>
  import("../views/Branch/Station_Management/priceManagers");
const ManagePriceLog = () =>
  import("../views/Branch/Station_Management/priceLog");
const BranchPumpCalibrationLogs = () =>
  import("../views/Branch/pump_calibration_logs/index");
const BranchProfile = () => import("../views/Branch/Profile/index");
const BranchPOS = () => import("../views/Branch/POS/index");
const BranchPosTerminalsDetails = () =>
  import("../views/Branch/POS/terminalDetails");
const inventoryReport = () => import("../views/Branch/InventoryReport");
const BranchCashFlow = () => import("../views/Branch/CashFlow/index");
const ProductSummary = () => import("../views/Branch/productSummary/index");
const BranchInvoices = () => import("../views/Branch/Invoices/index");
const BranchInvoiceDetails = () =>
  import("../views/Branch/Invoices/invoiceDetails");
const BranchInvoicePayments = () =>
  import("../views/Branch/Invoices/invoicePayment");
const BranchAssets = () => import("../views/Branch/Assets/index");
const ParentAssets = () => import("../views/Branch/Assets/parentAssets");
const TankDippings = () => import("../views/Branch/TankDippings");
const BranchProductValuation = () => import("../views/Branch/ProductValuation");
const BranchProductFillsDetails = () => import("../views/Branch/Product_fills");
const BranchProductReceived = () => import("../views/Branch/Product_received");
const BranchFillsBreakdown = () =>
  import("../views/Branch/Product_fills/productFillsBreakdown");
const GenerateBankDeposit = () =>
  import("../views/Branch/Accounting/generateBankDeposit");
const AddBankLinkedDeposit = () =>
  import("../views/Branch/Accounting/addBankLinkedDeposit");
const BranchBankLinkedTransactions = () =>
  import("../views/Branch/Bank/bankLinkedTransactions");
const BranchTerminals = () => import("../views/Branch/POS/terminals");
const branchTankVariance = () =>
  import("../views/Branch/varianceReport/branchTankVariance");
const manualRecord = () => import("../views/Branch/manual_record/index");
const rejectedRecord = () =>
  import("../views/Branch/manual_record/rejected_data");
const updateRejectedRecord = () =>
  import("../views/Branch/manual_record/update_rejected_data");
const BranchRatingsBreakdown = () =>
  import("../views/Branch/Ratings/branchRatingsBreakdown");
const StaffRatings = () =>
  import("../views/Branch/People_management/staffRatings");
const StaffRating = () =>
  import("../views/Branch/People_management/staffRating");
const AddRating = () => import("../views/Branch/Ratings/addRating");
const BranchRatings = () => import("../views/Branch/Ratings/branchRating");
const branchSettings = () => import("../views/Branch/Settings/index");
const Lease = () => import("../views/Branch/Lease/index");
const BranchSpace = () => import("../views/Branch/Lease/branchSpace");
const CreateBranchSpace = () =>
  import("../views/Branch/Lease/createBranchSpace");
const CreateLease = () => import("../views/Branch/Lease/createLease");
const Occupants = () => import("../views/Branch/Lease/occupants");
const CreateOccupant = () => import("../views/Branch/Lease/createOccupant");
const PaymentRecords = () => import("../views/Branch/Lease/paymentRecords");
const AddPayment = () => import("../views/Branch/Lease/addPayment");
const NonWetProductsBranchSales = () =>
  import("../views/Branch/dry-stock/sales");
const CreateNonWetProductBranchSales = () =>
  import("../views/Branch/dry-stock/createSales");
const NonWetProductsBranchSupply = () =>
  import("../views/Branch/dry-stock/supplies");
const SalesDetails = () => import("../views/Branch/dry-stock/salesDetails");
const BranchServices = () => import("../views/Branch/Services/services");
const TransactionServices = () =>
  import("../views/Branch/Services/transactions");
const CreateBranchTransaction = () =>
  import("../views/Branch/Services/addtransaction");
const TransactionDetails = () =>
  import("../views/Branch/Services/transactionDetails");
const BranchSupplyDetails = () =>
  import("../views/Branch/dry-stock/supplyDetails");
const BranchServiceTransactions = () =>
  import("../views/Branch/Services/serviceTransactions");
const BranchProductSales = () =>
  import("../views/Branch/Reports/product-sales");
const PumpSummary = () => import("../views/Branch/Reports/pump-summary");
const BranchSettlementRequest = () =>
  import("../views/Branch/Settlement/settlementRequest");
const BranchRetainershipSales = () =>
  import("../views/Branch/Retainership/index");

// INDUSTRIAL BRANCH

import IndustrialBranchDashboard from "../views/Industrial/Branch/Dashboard/index.vue";
import IndustrialBranchTanks from "../views/Industrial/Branch/Tanks";
import IndustrialBranchReorderLevel from "../views/Industrial/Branch/Tank_reorder_level";
import IndustrialBranchTankProbe from "../views/Industrial/Branch/Tank-probe";
import IndustrialBranchTankDetails from "../views/Industrial/Branch/TankDetails";
import IndustrialBranchWalletBalance from "../views/Industrial/Branch/wallet_balance/index.vue";
import IndustrialBranchOrderManagement from "../views/Industrial/Branch/request_diesel/index.vue";
import IndustrialBranchConsumptionReport from "../views/Industrial/Branch/Reports/index.vue";
import IndustrialBranchTankTransactions from "../views/Industrial/Branch/Tank_transaction/index.vue";
import IndustrialBranchEvents from "../views/Industrial/Branch/Events/index.vue";
import IndustrialBranchTanksFilled from "../views/Industrial/Branch/Tanks_Filled/index.vue";
import IndustrialBranchWalletTransactions from "../views/Industrial/Branch/Wallet_Transactions/index.vue";
import IndustrialBranchTrackOrders from "../views/Industrial/Branch/Track_Order/index.vue";
import IndusrialBranchScheduleMaintenance from "../views/Industrial/Branch/Schedule_Maintenance/index.vue";
import IndusrialBranchAddMaintenance from "../views/Industrial/Branch/Schedule_Maintenance/add_maintenance";
import IndusrialBranchAddOrder from "../views/Industrial/Branch/request_diesel/add_order";
import IndusrialBranchFundWalletWallet from "../views/Industrial/Branch/Fund_wallet/index";
import IndusrialBranchMaintenanceHistory from "../views/Industrial/Branch/Schedule_Maintenance/maintenance_history.vue";
import IndustrialBranchCompleteOrder from "../views/Industrial/Branch/request_diesel/complete_order";
import IndustrialBranchProfile from "../views/Industrial/Branch/Profile/index";

// INDUSTRIAL ADMIN
import IndustrialAdminDashboard from "../views/Industrial/Admin/Dashboard";
import IndustrialAdminBranches from "../views/Industrial/Admin/Branches";
import IndustrialAdminWallet from "../views/Industrial/Admin/Wallet";
import IndustrialAdminReport from "../views/Industrial/Admin/Report";
import IndustrialAdminBranchTanks from "../views/Industrial/Admin/Branch_Tank";
import IndustrialAdminMaintenance from "../views/Industrial/Admin/Maintenance";
import IndustrialAdminOrderManagement from "../views/Industrial/Admin/Order_Management";
import IndustrialAdminGroupManagement from "../views/Industrial/Admin/GroupManagement";
import IndustrialAdminUsers from "../views/Industrial/Admin/Users/index";
import IndustrialAdminCreateUsers from "../views/Industrial/Admin/Users/createUser";
import IndustrialAdminUserDetails from "../views/Industrial/Admin/Users/userDetails";
import IndustrialAdminOrderDetails from "../views/Industrial/Admin/Order_Management/Order_Details";
import IndustrialAdminInvoices from "../views/Industrial/Admin/Invoices/index";
import IndustrialAdminInvoiceDetails from "../views/Industrial/Admin/Invoices/invoiceDetails";
import IndustrialAdminInvoicePayments from "../views/Industrial/Admin/Invoices/invoicePayment";
import IndustrialAdminSuccessPage from "../views/Industrial/Admin/Invoices/successPage";
import IndustrialAdminProfile from "../views/Industrial/Admin/Profile/index";
import IndustrialAdminMakePayment from "../views/Industrial/Admin/MakePayment/index";

// INDUSTRIAL GROUP
import IndustrialGroupDashboard from "../views/Industrial/Group/Dashboard";
import IndustrialGroupBranches from "../views/Industrial/Group/Branches";
import IndustrialGroupWallet from "../views/Industrial/Group/Wallet";
import IndustrialGroupReport from "../views/Industrial/Group/Report";
import IndustrialGroupBranchTanks from "../views/Industrial/Group/Branch_Tank";
import IndustrialGroupMaintenance from "../views/Industrial/Group/Maintenance";
import IndustrialGroupOrderManagement from "../views/Industrial/Group/Order_Management";
import IndustrialGroupOrderDetails from "../views/Industrial/Group/Order_Management/Order_Details";
import IndustrialGroupProfile from "../views/Industrial/Group/Profile/index";

// POS OWNERS
const PosOwnerTransactions = () => import("../views/posOwner/posTransactions");
const PosOwnerTerminals = () => import("../views/posOwner/Terminals");
const OwnerTerminalTransactions = () =>
  import("../views/posOwner/posTerminalTransactions");
const OwnerTransactionDetails = () =>
  import("../views/posOwner/posTransactionDetails");

// POS BANK
const PosBankTransactions = () => import("../views/posBank/posTransactions");
const PosBankTerminals = () => import("../views/posBank/Terminals");
const BankTerminalTransactions = () =>
  import("../views/posBank/posTerminalTransactions");
const PosTransactionDetails = () =>
  import("../views/posBank/posTransactionDetails");

// Support Admin
const SupportCompanies = () => import("../views/SupportAdmin");

// Payment conifirmation
import PaymentConfirmationComponent from "@/components/modals/paymentConfirmation";

// No access page
import NoAccess from "../views/Customer/noAccess";
import store from "../store";

// Error pages
const Forbidden = () => import("../views/ErrorPages/403");

Vue.use(VueRouter);

let routes = [
  // Industrial Branch Dashboard Routes
  {
    path: "/Industrial/Branch/add-maintenance",
    name: "industrialBranchAddMaintenance",
    component: IndusrialBranchAddMaintenance,
    meta: {
      authorize: true,
      authRoles: ["IndustryManager", "IndustryAdmin", "IndustryGroup"],
    },
  },

  // INDUSTRIAL BRANCH TANKS

  {
    path: "/Industrial/Branch/tanks",
    name: "industrialBranchTanks",
    component: IndustrialBranchTanks,
    meta: {
      authorize: true,
      authRoles: ["IndustryManager", "IndustryAdmin", "IndustryGroup"],
    },
  },

  // INDUSTRIAL BRANCH REORDER LEVEL

  {
    path: "/Industrial/Branch/Reorder-level",
    name: "industrialBranchReorderLevel",
    component: IndustrialBranchReorderLevel,
    meta: {
      authorize: true,
      authRoles: ["IndustryManager", "IndustryAdmin", "IndustryGroup"],
    },
  },

  // INDUSTRIAL BRANCH TANKS PROBE
  {
    path: "/Industrial/Branch/tank-probe",
    name: "industrialBranchTankProbe",
    component: IndustrialBranchTankProbe,
    meta: {
      authorize: true,
      authRoles: ["IndustryManager", "IndustryAdmin", "IndustryGroup"],
    },
  },

  {
    path: "/Industrial/Branch/tank-details",
    name: "industrialBranchTankDetails",
    component: IndustrialBranchTankDetails,
    meta: {
      authorize: true,
      authRoles: ["IndustryManager", "IndustryAdmin", "IndustryGroup"],
    },
  },

  {
    path: "/Industrial/Branch/complete-order",
    name: "industrialBranchCompleteOrder",
    component: IndustrialBranchCompleteOrder,
    meta: {
      authorize: true,
      authRoles: ["IndustryManager", "IndustryAdmin", "IndustryGroup"],
    },
  },

  {
    path: "/Industrial/Branch/maintenance-history",
    name: "industrialBranchMaintenanceHistory",
    component: IndusrialBranchMaintenanceHistory,
    meta: {
      authorize: true,
      authRoles: ["IndustryManager", "IndustryAdmin", "IndustryGroup"],
    },
  },
  {
    path: "/Industrial/Branch/fund-wallet",
    name: "industrialBranchFundWallet",
    component: IndusrialBranchFundWalletWallet,
    meta: {
      authorize: true,
      authRoles: ["IndustryManager", "IndustryAdmin", "IndustryGroup"],
    },
  },
  {
    path: "/Industrial/Branch/add-order",
    name: "IndusrialBranchAddOrder",
    component: IndusrialBranchAddOrder,
    meta: {
      authorize: true,
      authRoles: ["IndustryManager", "IndustryAdmin", "IndustryGroup"],
    },
  },
  {
    path: "/Industrial/Branch/Track-Order",
    name: "industrialBranchTrackOrder",
    component: IndustrialBranchTrackOrders,
    meta: {
      authorize: true,
      authRoles: ["IndustryManager", "IndustryAdmin", "IndustryGroup"],
    },
  },
  {
    path: "/Industrial/Branch/schedule-maintenace",
    name: "industrialBranchSchedule_maintenace",
    component: IndusrialBranchScheduleMaintenance,
    meta: {
      authorize: true,
      authRoles: ["IndustryManager", "IndustryAdmin", "IndustryGroup"],
    },
  },
  {
    path: "/Industrial/Branch/Wallet-Transactions",
    name: "industrialBranchWalletTransactionDetails",
    component: IndustrialBranchWalletTransactions,
    meta: {
      authorize: true,
      authRoles: ["IndustryManager", "IndustryAdmin", "IndustryGroup"],
    },
  },

  {
    path: "/Industrial/Branch/branch-tanks-filled",
    name: "industrial_branch_tanks_filled",
    component: IndustrialBranchTanksFilled,
    meta: {
      authorize: true,
      authRoles: ["IndustryManager", "IndustryAdmin", "IndustryGroup"],
    },
  },
  {
    path: "/Industrial/Branch/Tank-transactions",
    name: "industrial_branch_tank_transactions",
    component: IndustrialBranchTankTransactions,
    meta: {
      authorize: true,
      authRoles: ["IndustryManager", "IndustryAdmin", "IndustryGroup"],
    },
  },
  {
    path: "/Industrial/Branch/industrial-events",
    name: "industrial_branch_events",
    component: IndustrialBranchEvents,
    meta: {
      authorize: true,
      authRoles: ["IndustryManager", "IndustryAdmin", "IndustryGroup"],
    },
  },

  {
    path: "/Industrial/Branch/Dashboard",
    name: "IndustrialBranchDashboard",
    component: IndustrialBranchDashboard,
    meta: {
      authorize: true,
      authRoles: ["IndustryAdmin", "IndustryManager", "IndustryGroup"],
    },
  },
  {
    path: "/Industrial/Branch/consumption-reports",
    name: "industrial_branch_consumption_report",
    component: IndustrialBranchConsumptionReport,
    meta: {
      authorize: true,
      authRoles: ["IndustryManager", "IndustryAdmin", "IndustryGroup"],
    },
  },
  {
    path: "/Industrial/Branch/wallet-balance",
    name: "industrial_branch_wallet_balance",
    component: IndustrialBranchWalletBalance,
    meta: {
      authorize: true,
      authRoles: ["IndustryManager", "IndustryAdmin", "IndustryGroup"],
    },
  },
  {
    path: "/Industrial/Branch/Order-Management",
    name: "industrial_branch_order_management",
    component: IndustrialBranchOrderManagement,
    meta: {
      authorize: true,
      authRoles: ["IndustryManager", "IndustryAdmin", "IndustryGroup"],
    },
  },
  {
    path: "/Industrial/Branch/profile",
    name: "industrial_branch_profile",
    component: IndustrialBranchProfile,
    meta: {
      authorize: true,
      authRoles: ["IndustryManager", "IndustryAdmin", "IndustryGroup"],
    },
  },

  // INDUSTRIAL ADMIN ROUTES

  {
    path: "/Industrial/Admin/Dashboard",
    name: "industrial_admin_dashboard",
    component: IndustrialAdminDashboard,
    meta: {
      authorize: true,
      authRoles: ["IndustryAdmin"],
    },
  },

  {
    path: "/Industrial/Admin/Branches",
    name: "industrial_admin_branches",
    component: IndustrialAdminBranches,
    meta: {
      authorize: true,
      authRoles: ["IndustryAdmin"],
    },
  },
  {
    path: "/Industrial/Admin/Maintenance",
    name: "industrial_admin_maintenance",
    component: IndustrialAdminMaintenance,
    meta: {
      authorize: true,
      authRoles: ["IndustryAdmin"],
    },
  },

  {
    path: "/Industrial/Admin/Wallet",
    name: "industrial_admin_wallet",
    component: IndustrialAdminWallet,
    meta: {
      authorize: true,
      authRoles: ["IndustryAdmin"],
    },
  },

  {
    path: "/Industrial/Admin/report",
    name: "industrial_admin_report",
    component: IndustrialAdminReport,
    meta: {
      authorize: true,
      authRoles: ["IndustryAdmin"],
    },
  },

  {
    path: "/Industrial/Admin/branch-tank-report",
    name: "industrial_admin_branch_tank_report",
    component: IndustrialAdminBranchTanks,
    meta: {
      authorize: true,
      authRoles: ["IndustryAdmin"],
    },
  },

  {
    path: "/Industrial/Admin/Order-management",
    name: "industrial_admin_order_management",
    component: IndustrialAdminOrderManagement,
    meta: {
      authorize: true,
      authRoles: ["IndustryAdmin"],
    },
  },

  {
    path: "/Industrial/Admin/group-management",
    name: "industrial_admin_group_management",
    component: IndustrialAdminGroupManagement,
    meta: {
      authorize: true,
      authRoles: ["IndustryAdmin"],
    },
  },

  {
    path: "/Industrial/Admin/users",
    name: "industrial_admin_users",
    component: IndustrialAdminUsers,
    meta: {
      authorize: true,
      authRoles: ["IndustryAdmin"],
    },
  },

  {
    path: "/Industrial/Admin/create-users",
    name: "industrial_admin_create_users",
    component: IndustrialAdminCreateUsers,
    meta: {
      authorize: true,
      authRoles: ["IndustryAdmin"],
    },
  },

  {
    path: "/Industrial/Admin/user-details",
    name: "industrial_admin_user_details",
    component: IndustrialAdminUserDetails,
    meta: {
      authorize: true,
      authRoles: ["IndustryAdmin"],
    },
  },

  {
    path: "/Industrial/Admin/Order-details",
    name: "industrial_admin_order_details",
    component: IndustrialAdminOrderDetails,
    meta: {
      authorize: true,
      authRoles: ["IndustryAdmin"],
    },
  },
  {
    path: "/Industrial/Admin/invoices",
    name: "industrial_admin_invoice",
    // component: IndustrialAdminInvoices,
    redirect: { name: "not_found" },
    meta: {
      authorize: true,
      authRoles: ["IndustryAdmin"],
    },
  },
  {
    path: "/Industrial/Admin/invoice-details",
    name: "industrial_admin_invoice_details",
    // component: IndustrialAdminInvoiceDetails,
    redirect: { name: "not_found" },
    meta: {
      authorize: true,
      authRoles: ["IndustryAdmin"],
    },
  },
  {
    path: "/Industrial/Admin/invoice-payments",
    name: "industrial_admin_invoice_payments",
    // component: IndustrialAdminInvoicePayments,
    redirect: { name: "not_found" },
    meta: {
      authorize: true,
      authRoles: ["IndustryAdmin"],
    },
  },
  {
    path: "/Industrial/Admin/monoResponse",
    name: "industrial_admin_success-page",
    // component: IndustrialAdminSuccessPage,
    redirect: { name: "not_found" },
    meta: {
      authorize: true,
      authRoles: ["IndustryAdmin"],
    },
  },
  {
    path: "/Industrial/Admin/admin-profile",
    name: "industrial_admin_profile",
    component: IndustrialAdminProfile,
    meta: {
      authorize: true,
      authRoles: ["IndustryAdmin"],
    },
  },
  {
    path: "/Industrial/Admin/make-payment",
    name: "industrial_make_payment",
    component: IndustrialAdminMakePayment,
    meta: {
      authorize: true,
      authRoles: ["IndustryAdmin"],
    },
  },
  // INDUSTRIAL GROUP ROUTES

  {
    path: "/Industrial/Group/Dashboard",
    name: "industrial_group_dashboard",
    component: IndustrialGroupDashboard,
    meta: {
      authorize: true,
      authRoles: ["IndustryGroup"],
    },
  },

  {
    path: "/Industrial/Group/Branches",
    name: "industrial_group_branches",
    component: IndustrialGroupBranches,
    meta: {
      authorize: true,
      authRoles: ["IndustryGroup"],
    },
  },
  {
    path: "/Industrial/Group/Maintenance",
    name: "industrial_group_maintenance",
    component: IndustrialGroupMaintenance,
    meta: {
      authorize: true,
      authRoles: ["IndustryGroup"],
    },
  },

  {
    path: "/Industrial/Group/Wallet",
    name: "industrial_group_wallet",
    component: IndustrialGroupWallet,
    meta: {
      authorize: true,
      authRoles: ["IndustryGroup"],
    },
  },

  {
    path: "/Industrial/Group/report",
    name: "industrial_group_report",
    component: IndustrialGroupReport,
    meta: {
      authorize: true,
      authRoles: ["IndustryGroup"],
    },
  },

  {
    path: "/Industrial/Group/branch-tank-report",
    name: "industrial_group_branch_tank_report",
    component: IndustrialGroupBranchTanks,
    meta: {
      authorize: true,
      authRoles: ["IndustryGroup"],
    },
  },

  {
    path: "/Industrial/Group/Order-management",
    name: "industrial_group_order_management",
    component: IndustrialGroupOrderManagement,
    meta: {
      authorize: true,
      authRoles: ["IndustryGroup"],
    },
  },

  {
    path: "/Industrial/Group/Order-details",
    name: "industrial_group_order_details",
    component: IndustrialGroupOrderDetails,
    meta: {
      authorize: true,
      authRoles: ["IndustryGroup"],
    },
  },
  {
    path: "/Industrial/Group/profile",
    name: "industrial_group_profile",
    component: IndustrialGroupProfile,
    meta: {
      authorize: true,
      authRoles: ["IndustryGroup"],
    },
  },

  // Retail Outlets Routes
  {
    path: "/Retail-outlet/bank-account-request",
    name: "branch-bank-account-request",
    component: BranchBankAcctRequest,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "SupportAdmin",
        "Sub Branch Manager",
        "DealerSubBranchManager",
        "PartnerAdmin",
      ],
    },
  },
  {
    path: "/Retail-Outlet/Dashboard",
    name: "branchDashboard",
    component: BranchDashboard,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "SupportAdmin",
        "Sub Branch Manager",
        "DealerSubBranchManager",
        "PartnerAdmin",
      ],
    },
  },
  {
    path: "/Retail-outlet/users",
    name: "branch_users",
    component: BranchUsers,
    meta: {
      authorize: true,
      authRoles: ["Company", "BranchManager", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Retail-Outlet/stock-valuation",
    name: "branch_stock_valuation",
    component: BranchProductValuation,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "SupportAdmin",
        "Sub Branch Manager",
        "DealerSubBranchManager",
        "PartnerAdmin",
      ],
    },
  },

  {
    path: "/Retail-Outlet/pump-maintenance",
    name: "branch_pump_maintenance",
    component: PumpsMaintenance,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "SupportAdmin",
        "Sub Branch Manager",
        "DealerSubBranchManager",
        "PartnerAdmin",
      ],
    },
  },
  {
    path: "/Retail-Outlet/maintenance",
    name: "maintenance-details",
    component: Maintenance,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "SupportAdmin",
        "Sub Branch Manager",
        "PartnerAdmin",
      ],
    },
  },
  {
    path: "/Retail-Outlet/faults-maintenance",
    name: "faults-maintenance",
    component: FaultsMaintenance,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "SupportAdmin",
        "Sub Branch Manager",
        "PartnerAdmin",
      ],
    },
  },

  // BRANCH TRANSACTION HISTORY
  {
    path: "/branch-transactions",
    name: "branchTransactions",
    component: BranchTransactions,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "SupportAdmin",
        "Sub Branch Manager",
        "PartnerAdmin",
        "viewESales",
      ],
    },
  },

  //BRANCH SETTLEMENT TRANSACTION

  {
    path: "/branch-settlement-transactions",
    name: "branchSettlementTransactions",
    component: BranchSettlementTransactions,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "SupportAdmin",
        "PartnerAdmin",
        "viewESales",
      ],
    },
  },

  //BRANCH SUFFICENCY METRICS
  {
    path: "/Retail-Outlet/sufficiency-metrics",
    name: "branch-sufficiency",
    component: BranchSufficiency,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "SupportAdmin",
        "Sub Branch Manager",
        "PartnerAdmin",
      ],
    },
  },

  {
    path: "/Retail-Outlet/Reports/pump-summary",
    name: "pump-summary",
    component: PumpSummary,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "SupportAdmin",
        "Sub Branch Manager",
        "DealerSubBranchManager",
        "PartnerAdmin",
      ],
    },
  },

  {
    path: "/Retail-Outlet/generate-bank-deposit",
    name: "generate-bank-deposit",
    component: GenerateBankDeposit,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "SupportAdmin",
        "Sub Branch Manager",
        "DealerSubBranchManager",
        "PartnerAdmin",
      ],
    },
  },
  {
    path: "/Retail-Outlet/branch-services",
    name: "branch-services",
    component: BranchServices,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "SupportAdmin",
        "PartnerAdmin",
        "Sub Branch Manager",
        "DealerSubBranchManager",
      ],
    },
  },

  {
    path: "/Retail-Outlet/add-bank-linked-deposit",
    name: "add-bank-linked-deposit",
    component: AddBankLinkedDeposit,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "SupportAdmin",
        "Sub Branch Manager",
        "DealerSubBranchManager",
        "PartnerAdmin",
      ],
    },
  },

  {
    path: "/Retail-Outlet/pumps-calibration",
    name: "pumps_calibration",
    component: PumpsCalibration,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "SupportAdmin",
        "Sub Branch Manager",
        "DealerSubBranchManager",
        "PartnerAdmin",
      ],
    },
  },
  {
    path: "/dry-stock/supplies",
    name: "NonWetProductsBranchSupply",
    component: NonWetProductsBranchSupply,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "SupportAdmin",
        "Sub Branch Manager",
        "DealerSubBranchManager",
        "PartnerAdmin",
      ],
    },
  },
  {
    path: "/Retail-outlet/product-sales",
    name: "branch-product-sales",
    component: BranchProductSales,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "SupportAdmin",
        "Sub Branch Manager",
        "DealerSubBranchManager",
        "PartnerAdmin",
      ],
    },
  },

  {
    path: "/Retail-outlet/services/create-transactions",
    name: "CreateBranchTransaction",
    component: CreateBranchTransaction,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "SupportAdmin",
        "Sub Branch Manager",
        "DealerSubBranchManager",
        "PartnerAdmin",
      ],
    },
  },

  {
    path: "/Retail-Outlet/pump-fault",
    name: "pump_fault",
    component: RecordPumpsFaults,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "SupportAdmin",
        "Sub Branch Manager",
        "DealerSubBranchManager",
        "PartnerAdmin",
      ],
    },
  },
  {
    path: "/Retail-Outlet/tank-dippings",
    name: "tank_dippings",
    component: TankDippings,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "SupportAdmin",
        "Sub Branch Manager",
        "DealerSubBranchManager",
        "PartnerAdmin",
      ],
    },
  },
  {
    path: "/Retail-Outlet/branch-space",
    name: "BranchSpace",
    component: BranchSpace,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "SupportAdmin",
        "PartnerAdmin",
        "Sub Branch Manager",
        "DealerSubBranchManager",
      ],
    },
  },

  {
    path: "/Retail-Outlet/BranchTerminals",
    name: "BranchTerminals",
    component: BranchTerminals,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "SupportAdmin",
        "Sub Branch Manager",
        "DealerSubBranchManager",
        "PartnerAdmin",
      ],
    },
  },

  {
    path: "/Retail-Outlet/pumps-average-time-per-litre",
    name: "pumps_average_time_per_litre",
    component: AverageTimePerLitre,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "SupportAdmin",
        "Sub Branch Manager",
        "DealerSubBranchManager",
        "PartnerAdmin",
      ],
    },
  },

  {
    path: "/Retail-Outlet/Ratings/breakdown",
    name: "BranchRatingsBreakdown",
    component: BranchRatingsBreakdown,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "SupportAdmin",
        "Sub Branch Manager",
        "DealerSubBranchManager",
        "PartnerAdmin",
      ],
    },
  },

  {
    path: "/Retail-Outlet/tank-variance",
    name: "branchTankVariance",
    component: branchTankVariance,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "Sub Branch Manager",
        "DealerSubBranchManager",
        "SupportAdmin",
        "PartnerAdmin",
      ],
    },
  },
  {
    path: "/Retail-Outlet/leases",
    name: "branch_Lease",
    component: Lease,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "BranchManager",
        "Sub Branch Manager",
        "DealerSubBranchManager",
        "SupportAdmin",
        "PartnerAdmin",
      ],
    },
  },

  {
    path: "/Retail-Outlet/manual-record",
    name: "manualRecord",
    component: manualRecord,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "Sub Branch Manager",
        "DealerSubBranchManager",
        "SupportAdmin",
        "PartnerAdmin",
      ],
    },
  },

  {
    path: "/Retail-Outlet/rejected-records",
    name: "rejectedRecord",
    component: rejectedRecord,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "Sub Branch Manager",
        "DealerSubBranchManager",
        "SupportAdmin",
        "PartnerAdmin",
      ],
    },
  },

  {
    path: "/Retail-Outlet/update-rejected-record",
    name: "updateRejectedRecord",
    component: updateRejectedRecord,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "Sub Branch Manager",
        "DealerSubBranchManager",
        "SupportAdmin",
        "PartnerAdmin",
      ],
    },
  },

  {
    path: "/Retail-Outlet/settings",
    name: "branchSettings",
    component: branchSettings,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "Sub Branch Manager",
        "DealerSubBranchManager",
        "SupportAdmin",
        "PartnerAdmin",
      ],
    },
  },

  {
    path: "/Retail-Outlet/disconnected-pumps",
    name: "branch_disconnected_pumps",
    component: BranchDisconnectedPumps,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "SupportAdmin",
        "Sub Branch Manager",
        "DealerSubBranchManager",
        "PartnerAdmin",
      ],
    },
  },
  {
    path: "/Retail-Outlet/offline-pumps",
    name: "branch_offline_pumps",
    component: BranchOfflinePumps,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "SupportAdmin",
        "Sub Branch Manager",
        "DealerSubBranchManager",
        "PartnerAdmin",
      ],
    },
  },
  {
    path: "/Retail-Outlet/shift-assignments",
    name: "shift_assignments",
    component: ShiftAssignments,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "SupportAdmin",
        "Sub Branch Manager",
        "DealerSubBranchManager",
        "PartnerAdmin",
      ],
    },
  },

  {
    path: "/Retail-Outlet/shift-deposits",
    name: "shift_deposits",
    component: ShiftDeposits,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "SupportAdmin",
        "Sub Branch Manager",
        "DealerSubBranchManager",
        "PartnerAdmin",
      ],
    },
  },
  {
    path: "/Retail-Outlet/dry-stock-sales/details",
    name: "SalesDetails",
    component: SalesDetails,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "SupportAdmin",
        "Sub Branch Manager",
        "DealerSubBranchManager",
        "PartnerAdmin",
      ],
    },
  },
  {
    path: "/Retail-Outlet/bank-deposits",
    name: "branch_bank_deposits",
    component: BranchBankLinkedTransactions,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "SupportAdmin",
        "Sub Branch Manager",
        "DealerSubBranchManager",
        "PartnerAdmin",
      ],
    },
  },

  {
    path: "/Retail-Outlet/create-occupant",
    name: "CreateOccupant",
    component: CreateOccupant,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "SupportAdmin",
        "Sub Branch Manager",
        "DealerSubBranchManager",
        "PartnerAdmin",
      ],
    },
  },

  {
    path: "/Retail-Outlet/Targets",
    name: "targets",
    component: Targets,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "SupportAdmin",
        "Sub Branch Manager",
        "DealerSubBranchManager",
        "PartnerAdmin",
      ],
    },
  },
  {
    path: "/Retail-Outlet/edit-staff/:staffId",
    name: "edit_staff",
    component: EditStaff,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "SupportAdmin",
        "Sub Branch Manager",
        "DealerSubBranchManager",
        "PartnerAdmin",
      ],
    },
  },
  {
    path: "/Retail-Outlet/create-lease",
    name: "CreateLease",
    component: CreateLease,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "SupportAdmin",
        "PartnerAdmin",
        "Sub Branch Manager",
        "DealerSubBranchManager",
      ],
    },
  },

  {
    path: "/Retail-Outlet/staff-details/:staffId",
    name: "staff_details",
    component: StaffDetails,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "SupportAdmin",
        "Sub Branch Manager",
        "DealerSubBranchManager",
        "PartnerAdmin",
      ],
    },
  },
  {
    path: "/Retail-Outlet/sales-transactions",
    name: "BranchSalesTransactions",
    component: BranchSalesTransactions,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "SupportAdmin",
        "Sub Branch Manager",
        "DealerSubBranchManager",
        "PartnerAdmin",
      ],
    },
  },
  {
    path: "/Retail-Outlet/lease-payments/:leaseId",
    name: "PaymentRecords",
    component: PaymentRecords,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "SupportAdmin",
        "PartnerAdmin",
        "Sub Branch Manager",
        "DealerSubBranchManager",
      ],
    },
  },

  {
    path: "/Retail-Outlet/variance-report",
    name: "VarianceReport",
    component: VarianceReport,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "SupportAdmin",
        "Sub Branch Manager",
        "DealerSubBranchManager",
        "PartnerAdmin",
      ],
    },
  },
  {
    path: "/Retail-Outlet/pump-tank-report",
    name: "PumpTankReport",
    component: PumpTankReport,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "SupportAdmin",
        "Sub Branch Manager",
        "DealerSubBranchManager",
        "PartnerAdmin",
      ],
    },
  },

  {
    path: "/Retail-outlet/services/transactions",
    name: "TransactionDetails",
    component: TransactionDetails,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "SupportAdmin",
        "Sub Branch Manager",
        "DealerSubBranchManager",
        "PartnerAdmin",
      ],
    },
  },
  {
    path: "/Retail-Outlet/staff/ratings",
    name: "staffRatings",
    component: StaffRatings,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "SupportAdmin",
        "Sub Branch Manager",
        "DealerSubBranchManager",
        "PartnerAdmin",
      ],
    },
  },

  {
    path: "/Retail-Outlet/product-summary",
    name: "productSummary",
    component: ProductSummary,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "SupportAdmin",
        "Sub Branch Manager",
        "DealerSubBranchManager",
        "PartnerAdmin",
      ],
    },
  },
  {
    path: "/Retail-Outlet/invoices",
    name: "branch_invoice",
    // component: BranchInvoices,
    redirect: { name: "not_found" },
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "SupportAdmin",
        "Sub Branch Manager",
        "DealerSubBranchManager",
        "PartnerAdmin",
      ],
    },
  },
  {
    path: "/Retail-Outlet/invoice-details",
    name: "branch_invoice_details",
    // component: BranchInvoiceDetails,
    redirect: { name: "not_found" },
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "SupportAdmin",
        "Sub Branch Manager",
        "DealerSubBranchManager",
        "PartnerAdmin",
      ],
    },
  },
  {
    path: "/Retail-Outlet/transaction-ratings",
    name: "BranchRatings",
    component: BranchRatings,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "SupportAdmin",
        "Sub Branch Manager",
        "DealerSubBranchManager",
        "PartnerAdmin",
      ],
    },
  },
  {
    path: "/Retail-Outlet/Ratings/:staffId/:staffName",
    name: "StaffRating",
    component: StaffRating,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "SupportAdmin",
        "Sub Branch Manager",
        "DealerSubBranchManager",
        "PartnerAdmin",
      ],
    },
  },

  {
    path: "/Retail-Outlet/Lease/payment-records/add/:paymentId/:leaseId",
    name: "AddPayment",
    component: AddPayment,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "SupportAdmin",
        "PartnerAdmin",
        "Sub Branch Manager",
        "DealerSubBranchManager",
      ],
    },
  },

  {
    path: "/Retail-Outlet/supply/details",
    name: "BranchSupplyDetails",
    component: BranchSupplyDetails,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "SupportAdmin",
        "PartnerAdmin",
        "Sub Branch Manager",
        "DealerSubBranchManager",
      ],
    },
  },

  {
    path: "/Retail-Outlet/invoice-payments",
    name: "branch_invoice_payments",
    // component: BranchInvoicePayments,
    redirect: { name: "not_found" },
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "SupportAdmin",
        "Sub Branch Manager",
        "DealerSubBranchManager",
        "PartnerAdmin",
      ],
    },
  },
  {
    path: "/Retail-Outlet/end-of-the-day-report",
    name: "end_of_the_day_report",
    component: EndOfTheDayReport,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "SupportAdmin",
        "Sub Branch Manager",
        "DealerSubBranchManager",
        "PartnerAdmin",
      ],
    },
  },
  {
    path: "/Retail-Outlet/dry-stock/sales/create",
    name: "CreateNonWetProductBranchSales",
    component: CreateNonWetProductBranchSales,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "SupportAdmin",
        "Sub Branch Manager",
        "DealerSubBranchManager",
        "PartnerAdmin",
      ],
    },
  },

  {
    path: "/Retail-Outlet/tank-reports",
    name: "tank_reports",
    component: TankReports,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "SupportAdmin",
        "Sub Branch Manager",
        "DealerSubBranchManager",
        "PartnerAdmin",
      ],
    },
  },
  {
    path: "/Retail-Outlet/tanks",
    name: "tanks",
    component: Tanks,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "SupportAdmin",
        "Sub Branch Manager",
        "DealerSubBranchManager",
        "PartnerAdmin",
      ],
    },
  },
  {
    path: "/Retail-Outlet/tank-details/:tankId",
    name: "TankDetails",
    component: TankDetails,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "SupportAdmin",
        "Sub Branch Manager",
        "DealerSubBranchManager",
        "PartnerAdmin",
      ],
    },
  },
  {
    path: "/Retail-Outlet/dry-stock-sales",
    name: "NonWetProductsBranchSales",
    component: NonWetProductsBranchSales,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "SupportAdmin",
        "Sub Branch Manager",
        "DealerSubBranchManager",
        "PartnerAdmin",
      ],
    },
  },

  {
    path: "/Retail-Outlet/tank-probe-transactions/:tankId",
    name: "tanks_probe_transactions",
    component: ProbeTransaction,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "SupportAdmin",
        "Sub Branch Manager",
        "DealerSubBranchManager",
        "PartnerAdmin",
      ],
    },
  },
  {
    path: "/Retail-Outlet/tank-daily-report/:tankId",
    name: "tanks_daily_report",
    component: DailyReport,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "SupportAdmin",
        "Sub Branch Manager",
        "DealerSubBranchManager",
        "PartnerAdmin",
      ],
    },
  },
  {
    path: "/Retail-Outlet/tanks-filled",
    name: "branch_tanks_filled",
    component: BranchTanksFilled,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "SupportAdmin",
        "Sub Branch Manager",
        "DealerSubBranchManager",
        "PartnerAdmin",
      ],
    },
  },
  {
    path: "/Retail-Outlet/pumps",
    name: "pumps",
    component: Pumps,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "SupportAdmin",
        "Sub Branch Manager",
        "DealerSubBranchManager",
        "PartnerAdmin",
      ],
    },
  },
  {
    path: "/Retail-Outlet/pump/transactions/:pumpId",
    name: "pump_transactions",
    component: PumpTransactions,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "SupportAdmin",
        "Sub Branch Manager",
        "DealerSubBranchManager",
        "PartnerAdmin",
      ],
    },
  },
  {
    path: "/Retail-Outlet/pump-details/:pumpId",
    name: "pump_details",
    component: PumpDetails,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "SupportAdmin",
        "Sub Branch Manager",
        "DealerSubBranchManager",
        "PartnerAdmin",
      ],
    },
  },
  {
    path: "/Retail-Outlet/wallet",
    name: "branch_wallet",
    component: BranchWallet,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "SupportAdmin",
        "Sub Branch Manager",
        "DealerSubBranchManager",
        "PartnerAdmin",
        "viewESales",
      ],
    },
  },
  {
    path: "/Retail-Outlet/settlement-account",
    name: "settlement_account",
    component: SettlementAccount,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "SupportAdmin",
        "Sub Branch Manager",
        "DealerSubBranchManager",
        "PartnerAdmin",
      ],
    },
  },
  {
    path: "/Retail-Outlet/Occupants",
    name: "Occupants",
    component: Occupants,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "SupportAdmin",
        "PartnerAdmin",
        "Sub Branch Manager",
        "DealerSubBranchManager",
      ],
    },
  },
  {
    path: "/Retail-Outlet/Assets",
    name: "branch_assets",
    component: BranchAssets,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "SupportAdmin",
        "Sub Branch Manager",
        "DealerSubBranchManager",
        "PartnerAdmin",
      ],
    },
  },
  {
    path: "/Retail-Outlet/parent-assets",
    name: "parent_assets",
    component: ParentAssets,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "SupportAdmin",
        "Sub Branch Manager",
        "DealerSubBranchManager",
        "PartnerAdmin",
      ],
    },
  },
  {
    path: "/Retail-Outlet/people-management/staff",
    name: "staff",
    component: Staff,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "SupportAdmin",
        "Sub Branch Manager",
        "DealerSubBranchManager",
        "PartnerAdmin",
      ],
    },
  },
  {
    path: "/Retail-Outlet/products-filled",
    name: "branch_products_filled",
    component: BranchProductFillsDetails,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "SupportAdmin",
        "Sub Branch Manager",
        "DealerSubBranchManager",
        "PartnerAdmin",
      ],
    },
  },
  {
    path: "/Retail-Outlet/products-received",
    name: "branch_products_received",
    component: BranchProductReceived,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "SupportAdmin",
        "Sub Branch Manager",
        "DealerSubBranchManager",
        "PartnerAdmin",
      ],
    },
  },

  {
    path: "/Retail-Outlet/people-management/shift",
    name: "shift",
    component: Shift,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "SupportAdmin",
        "Sub Branch Manager",
        "DealerSubBranchManager",
        "PartnerAdmin",
      ],
    },
  },
  {
    path: "/Retail-Outlet/Accounting/bank-accounts",
    name: "bank_accounts",
    component: BankAccounts,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "SupportAdmin",
        "Sub Branch Manager",
        "DealerSubBranchManager",
        "PartnerAdmin",
      ],
    },
  },
  {
    path: "/Retail-Outlet/Accounting/expenses",
    name: "expenses",
    component: Expenses,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "SupportAdmin",
        "Sub Branch Manager",
        "DealerSubBranchManager",
        "PartnerAdmin",
      ],
    },
  },
  {
    path: "/Retail-Outlet/service/transactions/:serviceId",
    name: "BranchServiceTransactions",
    component: BranchServiceTransactions,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "SupportAdmin",
        "Sub Branch Manager",
        "DealerSubBranchManager",
        "PartnerAdmin",
      ],
    },
  },

  {
    path: "/Retail-Outlet/update-price",
    name: "update_price",
    component: UpdatePrice,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "SupportAdmin",
        "Sub Branch Manager",
        "DealerSubBranchManager",
        "PartnerAdmin",
      ],
    },
  },
  {
    path: "/Retail-Outlet/update-branch-price",
    name: "manage_price",
    component: ManagePrice,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "SupportAdmin",
        "Sub Branch Manager",
        "DealerSubBranchManager",
        "PartnerAdmin",
      ],
    },
  },
  {
    path: "/Retail-Outlet/branch-approve-price",
    name: "branch_approve_price",
    component: BranchApprovePrice,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "SupportAdmin",
        "Sub Branch Manager",
        "DealerSubBranchManager",
        "PartnerAdmin",
      ],
    },
  },
  {
    path: "/Retail-Outlet/price-managers",
    name: "branch_price_managers",
    component: BranchPriceManager,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "SupportAdmin",
        "Sub Branch Manager",
        "DealerSubBranchManager",
        "PartnerAdmin",
      ],
    },
  },
  {
    path: "/Retail-Outlet/branch-price-log",
    name: "manage_price_log",
    component: ManagePriceLog,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "SupportAdmin",
        "Sub Branch Manager",
        "DealerSubBranchManager",
        "PartnerAdmin",
      ],
    },
  },
  {
    path: "/Retail-Outlet/pump-calibration-logs",
    name: "branch_pump_calibration_logs",
    component: BranchPumpCalibrationLogs,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "SupportAdmin",
        "Sub Branch Manager",
        "DealerSubBranchManager",
        "PartnerAdmin",
      ],
    },
  },
  {
    path: "/Retail-Outlet/products-filled-details",
    name: "products_filled_details",
    component: BranchFillsBreakdown,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "SupportAdmin",
        "Sub Branch Manager",
        "DealerSubBranchManager",
        "PartnerAdmin",
      ],
    },
  },

  {
    path: "/Retail-Outlet/People-management/new-staff",
    name: "new_staff",
    component: NewStaff,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "SupportAdmin",
        "Sub Branch Manager",
        "DealerSubBranchManager",
        "PartnerAdmin",
      ],
    },
  },

  {
    path: "/Retail-Outlet/services-transactions",
    name: "TransactionServices",
    component: TransactionServices,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "SupportAdmin",
        "PartnerAdmin",
        "Sub Branch Manager",
        "DealerSubBranchManager",
      ],
    },
  },

  {
    path: "/BranchManager/profile",
    name: "branchProfile",
    component: BranchProfile,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "SupportAdmin",
        "Sub Branch Manager",
        "DealerSubBranchManager",
        "PartnerAdmin",
      ],
    },
  },
  {
    path: "/Retail-Outlet/POS",
    name: "branch_POS",
    component: BranchPOS,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "SupportAdmin",
        "Sub Branch Manager",
        "DealerSubBranchManager",
        "PartnerAdmin",
      ],
    },
  },

  {
    path: "/Retail-Outlet/POS-terminal-details",
    name: "branch-pos-terminals-details",
    component: BranchPosTerminalsDetails,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "SupportAdmin",
        "Sub Branch Manager",
        "DealerSubBranchManager",
        "PartnerAdmin",
      ],
    },
  },

  {
    path: "/Retail-Outlet/inventory-report",
    name: "inventory-report",
    component: inventoryReport,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "SupportAdmin",
        "Sub Branch Manager",
        "DealerSubBranchManager",
        "PartnerAdmin",
      ],
    },
  },
  {
    path: "/Retail-Outlet/cash-flow",
    name: "branch_cash_flow",
    component: BranchCashFlow,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "SupportAdmin",
        "Sub Branch Manager",
        "DealerSubBranchManager",
        "PartnerAdmin",
      ],
    },
  },
  {
    path: "/Retail-Outlet/branch-space/Add",
    name: "CreateBranchSpace",
    component: CreateBranchSpace,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "SupportAdmin",
        "PartnerAdmin",
        "Sub Branch Manager",
        "DealerSubBranchManager",
      ],
    },
  },
  {
    path: "/Retail-Outlet/settlement-request",
    name: "BranchSettlementRequest",
    component: BranchSettlementRequest,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "SupportAdmin",
        "PartnerAdmin",
        "Sub Branch Manager",
        "DealerSubBranchManager",
      ],
    },
  },
  {
    path: "/Retail-Outlet/retainership-sales",
    name: "BranchRetainershipSales",
    component: BranchRetainershipSales,
    meta: {
      authorize: true,
      authRoles: [
        "BranchManager",
        "SupportAdmin",
        "PartnerAdmin",
        "Sub Branch Manager",
        "DealerSubBranchManager",
      ],
    },
  },

  // Dealer routes
  {
    path: "/Dealer/dashboard",
    name: "dealerDashboard",
    component: Dealer,
    meta: {
      authorize: true,
      authRoles: ["Dealers", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Dealer/profile",
    name: "dealerProfile",
    component: DealerProfile,
    meta: {
      authorize: true,
      authRoles: ["Dealers", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Dealer/our-retail-outlets",
    name: "dealerBranches",
    component: DealerBranches,
    meta: {
      authorize: true,
      authRoles: ["Dealers", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Dealer/price-management",
    name: "dealer_price_management",
    component: DealerPriceManagement,
    meta: {
      authorize: true,
      authRoles: ["Dealers", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Dealer/report/sales",
    name: "dealerSales",
    component: DealerSales,
    meta: {
      authorize: true,
      authRoles: ["Dealers", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Dealer/report/variance-report",
    name: "dealer_variance_report",
    component: DealerVarianceReport,
    meta: {
      authorize: true,
      authRoles: ["Dealers", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Dealer/tank-variance",
    name: "dealerTankVariance",
    component: DealerTankVariance,
    meta: {
      authorize: true,
      authRoles: ["Dealers", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Dealer/tanks-filled",
    name: "dealer_tanks_filled",
    component: DealerTanksFilled,
    meta: {
      authorize: true,
      authRoles: ["Dealers", "SupportAdmin", "PartnerAdmin"],
    },
  },
  // {
  //   path: "/Dealer/cash-flow",
  //   name: "dealer_cash_flow",
  //   component: DealerCashFlow,
  //   meta: {
  //     authorize: true,
  //     authRoles: ["Dealers", "SupportAdmin", "PartnerAdmin"],
  //   },
  // },
  {
    path: "/Dealer/tank-stock",
    name: "dealer_tank_stock",
    component: DealerTankStock,
    meta: {
      authorize: true,
      authRoles: ["Dealers", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Dealer/branch-sales",
    name: "dealer_branch_sales",
    component: DealerBranchSales,
    meta: {
      authorize: true,
      authRoles: ["Dealers", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Dealer/products-filled",
    name: "dealer_products_filled",
    component: DealerProductsFilled,
    meta: {
      authorize: true,
      authRoles: ["Dealers", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Dealer/daily-branch-transaction",
    name: "DailyDealerBranchTrans",
    component: DailyDealerBranchTrans,
    meta: {
      authorize: true,
      authRoles: ["Dealers", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Dealer/products-valuation",
    name: "dealer-product-valuation",
    component: DealerProductValuation,
    meta: {
      authorize: true,
      authRoles: ["Dealers", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Dealer/dealer-branches-report",
    name: "DealerBranchesReport",
    component: DealerBranchesReport,
    meta: {
      authorize: true,
      authRoles: ["Dealers", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Dealer/send-report",
    name: "sendDealerReport",
    component: sendDealerReport,
    meta: {
      authorize: true,
      authRoles: ["Dealers", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Dealer/disconnected-pumps",
    name: "dealerDisconnectedPumps",
    component: DealerDisconnectedPumps,
    meta: {
      authorize: true,
      authRoles: ["Dealers", "SupportAdmin", "PartnerAdmin"],
    },
  },
  // {
  //   path: "/Dealer/shutdown-history",
  //   name: "dealerShutdownHistory",
  //   component: DealerShutdownHistory,
  //   meta: {
  //     authorize: true,
  //     authRoles: ["Dealers", "SupportAdmin", "PartnerAdmin"],
  //   },
  // },
  {
    path: "/Dealer/pumps-history",
    name: "dealerPumpsHistory",
    component: DealerPumpsHistory,
    meta: {
      authorize: true,
      authRoles: ["Dealers", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Dealer/offline-pumps",
    name: "DealerOfflinePumps",
    component: DealerOfflinePumps,
    meta: {
      authorize: true,
      authRoles: ["Dealers", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Dealer/expenses",
    name: "dealer_expenses",
    component: DealerExpenses,
    meta: {
      authorize: true,
      authRoles: ["Dealers", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Dealer/branches/expenses",
    name: "dealer_branches_expenses",
    component: DealerBranchesExpenses,
    meta: {
      authorize: true,
      authRoles: ["Dealers", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Dealer/Branches/expense-breakdown",
    name: "dealer_branc_expense_breakdown",
    component: DealerBranchesExpenseBreakdown,
    meta: {
      authorize: true,
      authRoles: ["Dealers", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Dealer/expenses-categories",
    name: "dealer_expenses_categories",
    component: DealerExpensesCategories,
    meta: {
      authorize: true,
      authRoles: ["Dealers", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Dealer/aggregated-faults",
    name: "DealerAggregatedFaults",
    component: DealerAggregatedFaults,
    meta: {
      authorize: true,
      authRoles: ["Dealers", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Dealer/maintenance-list",
    name: "DealerMaintenanceList",
    component: DealerMaintenanceList,
    meta: {
      authorize: true,
      authRoles: ["Dealers", "SupportAdmin", "PartnerAdmin"],
    },
  },

  //GROUP ROUTES
  {
    path: "/Group/dashboard",
    name: "groupDashboard",
    component: Group,
    meta: {
      authorize: true,
      authRoles: [
        "Team",
        "SalesRep",
        "RegionalEngineer",
        "SupportAdmin",
        "PartnerAdmin",
      ],
    },
  },
  {
    path: "/Group/profile",
    name: "groupProfile",
    component: GroupProfile,
    meta: {
      authorize: true,
      authRoles: [
        "Team",
        "SalesRep",
        "RegionalEngineer",
        "SupportAdmin",
        "PartnerAdmin",
      ],
    },
  },
  {
    path: "/Group/our-retail-outlets",
    name: "groupBranches",
    component: GroupBranches,
    meta: {
      authorize: true,
      authRoles: [
        "SalesRep",
        "RegionalEngineer",
        "Team",
        "GroupBranchList",
        "SupportAdmin",
        "PartnerAdmin",
      ],
    },
  },
  {
    path: "/Group/report/sales",
    name: "GroupSales",
    component: GroupSales,
    meta: {
      authorize: true,
      authRoles: [
        "Team",
        "SalesRep",
        "RegionalEngineer",
        "SupportAdmin",
        "PartnerAdmin",
      ],
    },
  },
  {
    path: "/Group/report/variance-report",
    name: "group_variance_report",
    component: GroupVarianceReport,
    meta: {
      authorize: true,
      authRoles: [
        "Team",
        "SalesRep",
        "RegionalEngineer",
        "SupportAdmin",
        "PartnerAdmin",
      ],
    },
  },
  {
    path: "/Group/Tank-variance",
    name: "groupTankVariance",
    component: GroupTankVariance,
    meta: {
      authorize: true,
      authRoles: [
        "Team",
        "SalesRep",
        "RegionalEngineer",
        "SupportAdmin",
        "PartnerAdmin",
      ],
    },
  },
  {
    path: "/Group/tanks-filled",
    name: "group_tanks_filled",
    component: GroupTanksFilled,
    meta: {
      authorize: true,
      authRoles: [
        "Team",
        "SalesRep",
        "RegionalEngineer",
        "SupportAdmin",
        "PartnerAdmin",
      ],
    },
  },
  {
    path: "/Group/cashflow",
    name: "group_cashflow",
    component: GroupCashFlow,
    meta: {
      authorize: true,
      authRoles: [
        "Team",
        "SalesRep",
        "RegionalEngineer",
        "SupportAdmin",
        "PartnerAdmin",
      ],
    },
  },
  {
    path: "/Group/tankstock",
    name: "group_tankstock",
    component: GroupTankStock,
    meta: {
      authorize: true,
      authRoles: [
        "Team",
        "SalesRep",
        "RegionalEngineer",
        "SupportAdmin",
        "PartnerAdmin",
      ],
    },
  },
  {
    path: "/Group/branch-sales",
    name: "group_branch_sales",
    component: GroupBranchSales,
    meta: {
      authorize: true,
      authRoles: [
        "Team",
        "SalesRep",
        "RegionalEngineer",
        "SupportAdmin",
        "PartnerAdmin",
      ],
    },
  },
  {
    path: "/Group/products-filled",
    name: "group_products_filled",
    component: GroupProductsFilled,
    meta: {
      authorize: true,
      authRoles: [
        "Team",
        "SalesRep",
        "RegionalEngineer",
        "SupportAdmin",
        "PartnerAdmin",
      ],
    },
  },
  {
    path: "/Group/stock-valuation",
    name: "group-product-valuation",
    component: GroupProductValuation,
    meta: {
      authorize: true,
      authRoles: [
        "Team",
        "SalesRep",
        "RegionalEngineer",
        "SupportAdmin",
        "PartnerAdmin",
      ],
    },
  },
  {
    path: "/Group/Services",
    name: "GroupServices",
    component: GroupServices,
    meta: {
      authorize: true,
      authRoles: [
        "Team",
        "SalesRep",
        "RegionalEngineer",
        "SupportAdmin",
        "PartnerAdmin",
      ],
    },
  },
  {
    path: "/Group/services/transactions",
    name: "GroupServicesTransactions",
    component: GroupServicesTransactions,
    meta: {
      authorize: true,
      authRoles: [
        "Team",
        "SalesRep",
        "RegionalEngineer",
        "SupportAdmin",
        "PartnerAdmin",
      ],
    },
  },
  {
    path: "/Group/service/transactions/:serviceId",
    name: "GroupserviceTransactions",
    component: GroupServiceTransactions,
    meta: {
      authorize: true,
      authRoles: [
        "Team",
        "SalesRep",
        "RegionalEngineer",
        "SupportAdmin",
        "PartnerAdmin",
      ],
    },
  },
  {
    path: "/Group/Lease",
    name: "GroupLease",
    component: GroupLease,
    meta: {
      authorize: true,
      authRoles: [
        "Team",
        "SalesRep",
        "RegionalEngineer",
        "SupportAdmin",
        "PartnerAdmin",
      ],
    },
  },
  {
    path: "/Group/dry-stock/supplies",
    name: "GroupNonWetProductSupply",
    component: GroupNonWetProductSupply,
    meta: {
      authorize: true,
      authRoles: [
        "Team",
        "SalesRep",
        "RegionalEngineer",
        "SupportAdmin",
        "PartnerAdmin",
      ],
    },
  },
  {
    path: "/Group/non-wet-product-Sales",
    name: "group-non-wet-product-Sales",
    component: GroupNonWetProductsSales,
    meta: {
      authorize: true,
      authRoles: [
        "Team",
        "SalesRep",
        "RegionalEngineer",
        "SupportAdmin",
        "PartnerAdmin",
      ],
    },
  },
  {
    path: "/Group/dry-stock-stock",
    name: "GroupProductStock",
    component: GroupProductStock,
    meta: {
      authorize: true,
      authRoles: [
        "Team",
        "SalesRep",
        "RegionalEngineer",
        "SupportAdmin",
        "PartnerAdmin",
      ],
    },
  },
  {
    path: "/Group/product-stock/details/:productId/:productName",
    name: "GroupproductStockDetails",
    component: GroupProductStockDetails,
    meta: {
      authorize: true,
      authRoles: [
        "Team",
        "SalesRep",
        "RegionalEngineer",
        "SupportAdmin",
        "PartnerAdmin",
      ],
    },
  },
  {
    path: "/Group/dry-stock-supply-history",
    name: "GroupSupplyHistory",
    component: GroupSupplyHistory,
    meta: {
      authorize: true,
      authRoles: [
        "Team",
        "SalesRep",
        "RegionalManager",
        "RegionalEngineer",
        "SupportAdmin",
        "PartnerAdmin",
      ],
    },
  },
  {
    path: "/Group/dry-stock/sales-history",
    name: "GroupSalesHistory",
    component: GroupSalesHistory,
    meta: {
      authorize: true,
      authRoles: [
        "Team",
        "SalesRep",
        "RegionalManager",
        "RegionalEngineer",
        "SupportAdmin",
        "PartnerAdmin",
      ],
    },
  },
  {
    path: "/Group/dry-stock/sale/details",
    name: "GroupsalesDetails",
    component: GroupsalesDetails,
    meta: {
      authorize: true,
      authRoles: [
        "Team",
        "SalesRep",
        "RegionalManager",
        "RegionalEngineer",
        "SupportAdmin",
        "PartnerAdmin",
      ],
    },
  },
  {
    path: "/Group/dry-stock-supplies/details",
    name: "GroupsupplyDetails",
    component: GroupsupplyDetails,
    meta: {
      authorize: true,
      authRoles: [
        "Team",
        "SalesRep",
        "RegionalManager",
        "RegionalEngineer",
        "SupportAdmin",
        "PartnerAdmin",
      ],
    },
  },
  {
    path: "/Group/bank-linked-transactions",
    name: "group-bank-linked-transactions",
    component: GroupBankLinkedTransactions,
    meta: {
      authorize: true,
      authRoles: [
        "Team",
        "SalesRep",
        "RegionalManager",
        "RegionalEngineer",
        "SupportAdmin",
        "PartnerAdmin",
      ],
    },
  },
  {
    path: "/Group/bank-transactions",
    name: "group-bank-transactions",
    component: GroupLiveBankTransactions,
    meta: {
      authorize: true,
      authRoles: [
        "Team",
        "SalesRep",
        "RegionalManager",
        "RegionalEngineer",
        "SupportAdmin",
        "PartnerAdmin",
      ],
    },
  },
  {
    path: "/Group/bank-transactions-details",
    name: "group-bank-transactions-breakdown",
    component: GroupLiveBankTransactionsBreakdown,
    meta: {
      authorize: true,
      authRoles: [
        "Team",
        "SalesRep",
        "RegionalManager",
        "RegionalEngineer",
        "SupportAdmin",
        "PartnerAdmin",
      ],
    },
  },

  // POS
  // {
  //   path: "/Group/POS",
  //   name: "group_POS",
  //   component: GroupPOS,
  //   meta: {
  //     authorize: true,
  //     authRoles: [
  //       "SalesRep",
  //       "RegionalManager",
  //       "RegionalEngineer",
  //       "SupportAdmin",
  //       "PartnerAdmin",
  //     ],
  //   },
  // },

  // group pos terminal
  // {
  //   path: "/Group/pos-terminals",
  //   name: "group-pos-terminals",
  //   component: GroupPosTerminals,
  //   meta: {
  //     authorize: true,
  //     authRoles: [
  //       "SalesRep",
  //       "RegionalManager",
  //       "RegionalEngineer",
  //       "SupportAdmin",
  //       "PartnerAdmin",
  //     ],
  //   },
  // },

  // group pos terminal details
  // {
  //   path: "/Group/pos-terminal-details",
  //   name: "group-pos-terminal-details",
  //   component: GroupPosTerminalsDetails,
  //   meta: {
  //     authorize: true,
  //     authRoles: [
  //       "SalesRep",
  //       "RegionalManager",
  //       "RegionalEngineer",
  //       "SupportAdmin",
  //       "PartnerAdmin",
  //     ],
  //   },
  // },

  {
    path: "/Group/aggregated-faults",
    name: "GroupAggregatedFaults",
    component: GroupAggregatedFaults,
    meta: {
      authorize: true,
      authRoles: [
        "Team",
        "SalesRep",
        "RegionalManager",
        "RegionalEngineer",
        "SupportAdmin",
        "PartnerAdmin",
      ],
    },
  },
  {
    path: "/Group/maintenance-list",
    name: "GroupMaintenanceList",
    component: GroupMaintenanceList,
    meta: {
      authorize: true,
      authRoles: [
        "Team",
        "SalesRep",
        "RegionalManager",
        "RegionalEngineer",
        "SupportAdmin",
        "PartnerAdmin",
      ],
    },
  },

  {
    path: "/Group/price-management",
    name: "group_price_management",
    component: GroupPriceManagement,
    meta: {
      authorize: true,
      authRoles: [
        "Team",
        "SalesRep",
        "RegionalManager",
        "RegionalEngineer",
        "SupportAdmin",
        "PartnerAdmin",
      ],
    },
  },
  {
    path: "/Group/price-approval",
    name: "group_approve_price",
    component: GroupPriceApproval,
    meta: {
      authorize: true,
      authRoles: [
        "Team",
        "SalesRep",
        "RegionalManager",
        "RegionalEngineer",
        "SupportAdmin",
        "PartnerAdmin",
      ],
    },
  },
  {
    path: "/Group/price-managers",
    name: "group_price_managers",
    component: GroupPriceManagers,
    meta: {
      authorize: true,
      authRoles: [
        "Team",
        "SalesRep",
        "RegionalManager",
        "RegionalEngineer",
        "SupportAdmin",
        "PartnerAdmin",
      ],
    },
  },
  {
    path: "/Group/branch-cluster",
    name: "group_branch_cluster",
    component: GroupBranchCluster,
    meta: {
      authorize: true,
      authRoles: [
        "Team",
        "SalesRep",
        "RegionalManager",
        "RegionalEngineer",
        "SupportAdmin",
        "PartnerAdmin",
      ],
    },
  },
  {
    path: "/Group/price-management-log",
    name: "group_price_management_log",
    component: GroupPriceManagementLog,
    meta: {
      authorize: true,
      authRoles: [
        "Team",
        "SalesRep",
        "RegionalManager",
        "RegionalEngineer",
        "SupportAdmin",
        "PartnerAdmin",
      ],
    },
  },

  {
    path: "/Group/pump-calibration-logs",
    name: "group_pump_calibration_logs",
    component: GroupPumpCalibrationLogs,
    meta: {
      authorize: true,
      authRoles: [
        "Team",
        "SalesRep",
        "RegionalManager",
        "RegionalEngineer",
        "SupportAdmin",
        "PartnerAdmin",
      ],
    },
  },

  {
    path: "/Group/wallet",
    name: "group_wallet",
    component: GroupWallet,
    meta: {
      authorize: true,
      authRoles: [
        "Team",
        "SalesRep",
        "RegionalManager",
        "RegionalEngineer",
        "SupportAdmin",
        "PartnerAdmin",
      ],
    },
  },

  //Region Routes
  {
    path: "/Region/dashboard",
    name: "regionDashboard",
    component: Region,
    meta: {
      authorize: true,
      authRoles: ["RegionalManager", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Region/profile",
    name: "regionProfile",
    component: RegionProfile,
    meta: {
      authorize: true,
      authRoles: ["RegionalManager", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Region/our-retail-outlets",
    name: "regionBranches",
    component: RegionBranches,
    meta: {
      authorize: true,
      authRoles: ["RegionalManager", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Region/report/sales",
    name: "RegionSales",
    component: RegionSales,
    meta: {
      authorize: true,
      authRoles: ["RegionalManager", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Region/report/variance-report",
    name: "region_variance_report",
    component: RegionVarianceReport,
    meta: {
      authorize: true,
      authRoles: ["RegionalManager", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Region/Tank-variance",
    name: "regionTankVariance",
    component: RegionTankVariance,
    meta: {
      authorize: true,
      authRoles: ["RegionalManager", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Region/tanks-filled",
    name: "region_tanks_filled",
    component: RegionTanksFilled,
    meta: {
      authorize: true,
      authRoles: ["RegionalManager", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Region/cashflow",
    name: "region_cashflow",
    component: RegionCashFlow,
    meta: {
      authorize: true,
      authRoles: ["RegionalManager", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Region/tankstock",
    name: "region_tankstock",
    component: RegionTankStock,
    meta: {
      authorize: true,
      authRoles: ["RegionalManager", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Region/branch-sales",
    name: "region_branch_sales",
    component: RegionBranchSales,
    meta: {
      authorize: true,
      authRoles: ["RegionalManager", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Region/products-filled",
    name: "region_products_filled",
    component: RegionProductsFilled,
    meta: {
      authorize: true,
      authRoles: ["RegionalManager", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Region/stock-valuation",
    name: "region-product-valuation",
    component: RegionProductValuation,
    meta: {
      authorize: true,
      authRoles: ["RegionalManager", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Region/Services",
    name: "RegionServices",
    component: RegionServices,
    meta: {
      authorize: true,
      authRoles: ["RegionalManager", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Region/service-transactions/:branchId/:branchName",
    name: "RegionServiceTransactionDetails",
    component: RegionServiceTransactionDetails,
    meta: {
      authorize: true,
      authRoles: ["RegionalManager", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Region/services/transactions",
    name: "RegionServicesTransactions",
    component: RegionServicesTransactions,
    meta: {
      authorize: true,
      authRoles: ["RegionalManager", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Region/service/transactions/:serviceId",
    name: "RegionserviceTransactions",
    component: RegionServiceTransactions,
    meta: {
      authorize: true,
      authRoles: ["RegionalManager", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Region/Lease",
    name: "RegionLease",
    component: RegionLease,
    meta: {
      authorize: true,
      authRoles: ["RegionalManager", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Region/dry-stock/supplies",
    name: "RegionNonWetProductSupply",
    component: RegionNonWetProductSupply,
    meta: {
      authorize: true,
      authRoles: ["RegionalManager", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Region/non-wet-product-Sales",
    name: "region-non-wet-product-Sales",
    component: RegionNonWetProductsSales,
    meta: {
      authorize: true,
      authRoles: ["RegionalManager", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Region/dry-stock-stock",
    name: "RegionProductStock",
    component: RegionProductStock,
    meta: {
      authorize: true,
      authRoles: ["RegionalManager", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Region/product-stock/details/:productId/:productName",
    name: "RegionproductStockDetails",
    component: RegionProductStockDetails,
    meta: {
      authorize: true,
      authRoles: ["RegionalManager", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Region/dry-stock-supply-history",
    name: "RegionSupplyHistory",
    component: RegionSupplyHistory,
    meta: {
      authorize: true,
      authRoles: ["RegionalManager", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Region/dry-stock/sales-history",
    name: "RegionSalesHistory",
    component: RegionSalesHistory,
    meta: {
      authorize: true,
      authRoles: ["RegionalManager", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Region/dry-stock/sale/details",
    name: "RegionsalesDetails",
    component: RegionsalesDetails,
    meta: {
      authorize: true,
      authRoles: ["RegionalManager", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Region/dry-stock-supplies/details",
    name: "RegionsupplyDetails",
    component: RegionsupplyDetails,
    meta: {
      authorize: true,
      authRoles: ["RegionalManager", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Region/bank-linked-transactions",
    name: "region-bank-linked-transactions",
    component: RegionBankLinkedTransactions,
    meta: {
      authorize: true,
      authRoles: ["RegionalManager", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Region/bank-transactions",
    name: "region-bank-transactions",
    component: RegionLiveBankTransactions,
    meta: {
      authorize: true,
      authRoles: ["RegionalManager", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Region/bank-transactions-details",
    name: "region-bank-transactions-breakdown",
    component: RegionLiveBankTransactionsBreakdown,
    meta: {
      authorize: true,
      authRoles: ["RegionalManager", "SupportAdmin", "PartnerAdmin"],
    },
  },

  // region pos

  // {
  //   path: "/Region/POS",
  //   name: "region_POS",
  //   component: RegionPOS,
  //   meta: {
  //     authorize: true,
  //     authRoles: ["RegionalManager", "SupportAdmin", "PartnerAdmin"],
  //   },
  // },

  // {
  //   path: "/Region/pos-terminal-details",
  //   name: "region-pos-terminal-details",
  //   component: RegionPosTerminalsDetails,
  //   meta: {
  //     authorize: true,
  //     authRoles: ["RegionalManager", "SupportAdmin", "PartnerAdmin"],
  //   },
  // },
  // {
  //   path: "/Region/pos-terminals",
  //   name: "region-pos-terminals",
  //   component: RegionPosTerminals,
  //   meta: {
  //     authorize: true,
  //     authRoles: ["RegionalManager", "SupportAdmin", "PartnerAdmin"],
  //   },
  // },

  {
    path: "/Region/aggregated-faults",
    name: "RegionAggregatedFaults",
    component: RegionAggregatedFaults,
    meta: {
      authorize: true,
      authRoles: ["RegionalManager", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Region/maintenance-list",
    name: "RegionMaintenanceList",
    component: RegionMaintenanceList,
    meta: {
      authorize: true,
      authRoles: ["RegionalManager", "SupportAdmin", "PartnerAdmin"],
    },
  },

  // Company routes
  {
    path: "/Company/bank-account-request",
    name: "bank-account-request",
    component: BankAcctRequest,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/dashboard",
    name: "companyDashboard",
    component: Company,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/aggregated-faults",
    name: "AggregatedFaults",
    component: AggregatedFaults,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/maintenance-list",
    name: "MaintenanceList",
    component: MaintenanceList,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/waybill",
    name: "Waybill",
    component: Waybill,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/trucks-and-drivers",
    name: "TrucksAndDrivers",
    component: TrucksAndDrivers,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/alerts-and-alarm",
    name: "alerts_and_alarm",
    component: AlertAlarm,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/make-payment",
    name: "make_payment",
    component: MakePayment,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/make-stripe-payment",
    name: "make_payment_stripe",
    component: MakePaymentStripe,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/group-management",
    name: "CompanyGroup",
    component: CompanyGroup,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/region",
    name: "CompanyRegion",
    component: CompanyRegion,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/user/add-role",
    name: "company-add-user-role",
    component: MapUserToRole,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/pos-terminals",
    name: "company-pos-terminals",
    component: PosTerminals,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },

  {
    path: "/Company/pos-terminals-details",
    name: "company-pos-terminals-details",
    component: PosTerminalsDetails,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/link-bank-account",
    name: "link_company_bank_account",
    component: LinkBankAccounts,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/subscription-transactions",
    name: "subscription-transactions",
    // component: SubscriptionTransactions,
    redirect: { name: "not_found" },
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/add-service",
    name: "AddService",
    component: AddService,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/create-lease",
    name: "CompanyCreateLease",
    component: CompanyCreateLease,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },

  {
    path: "/Company/subscription-transactions-breakdown",
    name: "subscription-transactions-breakdown",
    // component: SubscriptionsTransactionsBreakdown,
    redirect: { name: "not_found" },
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/branch-spaces/create",
    name: "CreateCompanyBranchSpace",
    component: CreateCompanyBranchSpace,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },

  {
    path: "/Company/dry-stock-sales-breakdown",
    name: "salesBreakdown",
    component: salesBreakdown,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/services/transactions",
    name: "CompanyServicesTransactions",
    component: CompanyServicesTransactions,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/service/transactions/:serviceId",
    name: "serviceTransactions",
    component: ServiceTransactions,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },

  {
    path: "/Company/bank-linked-transactions",
    name: "bank-linked-transactions",
    component: BankLinkedTransactions,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/company-branches-report",
    name: "CompanyBranchesReport",
    component: CompanyBranchesReport,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/dry-stock/sales-history",
    name: "SalesHistory",
    component: SalesHistory,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },

  {
    path: "/Company/dry-stock-stock",
    name: "BranchProductStock",
    component: BranchProductStock,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/Leases",
    name: "CompanyLease",
    component: CompanyLease,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin"],
    },
  },

  {
    path: "/Company/Order/create-order",
    name: "create_order",
    component: CreateOrder,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },

  {
    path: "/Company/dry-stock",
    name: "NonWetProducts",
    component: NonWetProducts,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/recurring-payment-status",
    name: "recurring-payment-status",
    component: RecurringPaymentStatusPage,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/dry-stock-supply-history",
    name: "SupplyHistory",
    component: SupplyHistory,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/branch-spaces",
    name: "companyBranchSpace",
    component: CompanyBranchSpace,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },

  {
    path: "/Company/Services",
    name: "CompanyServices",
    component: CompanyServices,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },

  {
    path: "/Company/Order/assign-driver",
    name: "assignDriver",
    component: AssignDriverToOrder,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  // {
  //     path: "/Company/Partner/Companies",
  //     name: "PartnerCompanies",
  //     component: PartnerCompanies,
  //     meta: {
  //         authorize: true,
  //         authRoles: ['Company', 'SupportAdmin']
  //     }
  // },
  //  REGION SALES DETAILS

  {
    path: "/region-sales-report",
    name: "region-sales-report",
    component: RegionSalesReport,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },

  {
    path: "/Company/Tank-variance",
    name: "companyTankVariance",
    component: companyTankVariance,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/dry-stock-categotries/create",
    name: "CreateNonWetProductsCategories",
    component: CreateNonWetProductsCategories,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },

  {
    path: "/Company/bank-transactions-details",
    name: "bank-transactions-breakdown",
    component: LiveBankTransactionsBreakdown,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },

  {
    path: "/company-transactions",
    name: "companyTransactions",
    component: CompanyTransactions,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },

  {
    path: "/company-wallet",
    name: "companyWallet",
    component: CompanyWallet,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },

  {
    path: "/Company/wallet",
    name: "company_wallet",
    component: CompanyWallets,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },

  {
    path: "/Company/wallet-top-up",
    name: "company_wallet_topup",
    component: CompanyWalletTopUp,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },

  {
    path: "/company/dry-stock-supplies/details",
    name: "supplyDetails",
    component: supplyDetails,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },

  {
    path: "/non-wet-product-Sales",
    name: "non-wet-product-Sales",
    component: NonWetProductsSales,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/company/send-report",
    name: "sendReport",
    component: sendReport,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/company/product-stock/details/:productId/:productName",
    name: "productStockDetails",
    component: ProductStockDetails,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/company/dry-stock/supplies",
    name: "NonWetProductSupply",
    component: NonWetProductSupply,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/company/daily-branch-Transactions",
    name: "DailyBranchTrans",
    component: DailyBranchTrans,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/tank-sales",
    name: "company_tank_sales",
    component: CompanyTankSales,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/Order/edit-order",
    name: "edit_order",
    component: EditOrder,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  // {
  //     path: "/Company/acquisition-partners/Add",
  //     name: "AddPartners",
  //     component: AddPartners,
  //     meta: {
  //         authorize: true,
  //         authRoles: ['Company', 'SupportAdmin']
  //     }
  // },

  {
    path: "/Company/Disconnected-pumps/History",
    name: "disconnected_pumps_history",
    component: DisconnectedPumpHistory,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },

  {
    path: "/Company/link-bank",
    name: "link-company-bank",
    component: LinkCompanyBankAccounts,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },

  {
    path: "/Company/Order/manage-orders",
    name: "manage_orders",
    component: ManageOrders,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/dry-stock/sale/details",
    name: "salesDetails",
    component: salesDetails,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },

  {
    path: "/Company/Assets/Groups/details",
    name: "asset_groups",
    component: ViewAssetsGroups,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/dry-stock/categories",
    name: "NonWetProductsCategories",
    component: NonWetProductsCategories,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  //COMPANY SUFFICENCY METRICS
  {
    path: "/Company/sufficiency-metrics",
    name: "company-sufficiency",
    component: CompanySufficiency,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },

  {
    path: "/Company/dry-stock/create",
    name: "CreateNonWetProduct",
    component: CreateNonWetProduct,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },

  {
    path: "/Company/Report/variance-report",
    name: "company_variance_report",
    component: CompanyVarianceReport,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },

  //  {
  //     path: "/Company/acquiring-partners",
  //     name: "acquiring-partners",
  //     component: Partners,
  //     meta: {
  //         authorize: true,
  //         authRoles: ['Company', 'SupportAdmin']
  //     }
  // },

  {
    path: "/Company/asset-groups",
    name: "assets",
    component: Assets,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/products-filled-details",
    name: "company_products_filled",
    component: CompanyProductFillsDetails,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/recurring-payment-breakdown",
    name: "recurring-payment-breakdown",
    component: RecurringBreakdown,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/price-management",
    name: "price_management",
    component: PriceManagement,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/price-management-log",
    name: "price_management_log",
    component: PriceManagementLog,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/approve-price",
    name: "approve_price",
    component: ApprovePrice,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/branch-cluster",
    name: "branch_cluster",
    component: BranchCluster,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },

  {
    path: "/Company/price-managers",
    name: "price_managers",
    component: PriceManagers,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/pump-calibration-logs",
    name: "pump_calibration_logs",
    component: PumpCalibrationLogs,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/Invoices/set-recurring-invoice",
    name: "set-recurring-invoice",
    // component: SetRecurring,
    redirect: { name: "not_found" },
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },

  {
    path: "/Company/report/sales",
    name: "companySales",
    component: CompanySales,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/total-sales",
    name: "companyTotalSales",
    component: CompanyTotalSales,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/non-wet-product/supplies/create",
    name: "CreateNonWetProductSupply",
    component: CreateNonWetProductSupply,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },

  {
    path: "/Company/stock-valuation",
    name: "company-product-valuation",
    component: CompanyProductValuation,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/offline-pumps",
    name: "offlinePumps",
    component: OfflinePumps,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/disconnected-pumps",
    name: "disconnectedPumps",
    component: DisconnectedPumps,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/shutdown-history",
    name: "shutdownHistory",
    component: shutdownHistory,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },

  {
    path: "/Company/Our-dealers",
    name: "our_dealers",
    component: OurDealers,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/:branchName/Leases/:branchId",
    name: "CompanyBranchLeases",
    component: CompanyBranchLeases,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/Our-Retail-Outlets",
    name: "our_branches",
    component: OurBranches,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/manage-expenses",
    name: "manage_expenses",
    component: ManageExpenses,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/expenses",
    name: "company_expenses",
    component: CompanyExpenses,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/branches/expenses",
    name: "company_branches_expenses",
    component: CompanyBranchesExpenses,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/bank-accounts",
    name: "company_accounts",
    component: CompanyAccounts,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/expenses-categories",
    name: "expenses_categories",
    component: ExpensesCategories,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/Fund-wallet-request",
    name: "fund_wallet_request",
    component: FundWalletRequest,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/bank-transactions",
    name: "bank-transactions",
    component: LiveBankTransactions,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },

  {
    path: "/Company/Zones",
    name: "zones",
    component: Zones,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/manage-drivers",
    name: "manage_drivers",
    component: ManageDrivers,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/manage-trucks",
    name: "manage_trucks",
    component: ManageTrucks,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/tank-stock",
    name: "company_tank_stock",
    component: TankStock,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/assign-truck",
    name: "assignTruck",
    component: AssignTruck,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/assigned-truck",
    name: "assignedTruck",
    component: AssignedTruck,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/products",
    name: "company_products",
    component: DeliverableProducts,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/product-LGAs",
    name: "company_product_LGAs",
    component: ProductLGA,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/branch-sales",
    name: "company_branch_sales",
    component: CompanyBranchSales,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/add-product",
    name: "add_product",
    component: AddProduct,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/service-transactions/:branchId/:branchName",
    name: "ServiceTransactionDetails",
    component: ServiceTransactionDetails,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },

  {
    path: "/Company/assigned-orders",
    name: "assignedOrders",
    component: AssignedOrders,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/Assign-Branches",
    name: "assignBranches",
    component: AssignBranches,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/Zone-Branches",
    name: "zoneBranches",
    component: ZoneBranches,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },

  {
    path: "/Company/retainership",
    name: "remisRetainership",
    component: RemisRetainership,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },

  {
    path: "/Company/retainership-details",
    name: "retainer-details",
    component: RetainerDetails,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/card-transactions",
    name: "card-transactions",
    component: CardTransactions,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },

  {
    path: "/Company/retainership/card-request",
    name: "card-request",
    component: RetainershipCardRequest,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },

  {
    path: "/Company/retainership/approve-retainership-card-request",
    name: "approve-retainership-card-request",
    component: ApproveRetainershipCardRequest,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },

  // {
  //   path: "/Company/retainership",
  //   name: "companyRetainership",
  //   component: CompanyRetainership,
  //   meta: {
  //     authorize: true,
  //     authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
  //   },
  // },
  {
    path: "/Company/retainership-sales",
    name: "companyRetainershipSales",
    component: CompanyRetainershipSales,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },

  {
    path: "/Company/all-cards",
    name: "all-cards",
    component: AllCards,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/retainership/wallet-transactions",
    name: "RetainershipWalletTransactions",
    component: RetainershipWalletTransactions,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },

  {
    path: "/Company/retainership/all-wallet-transactions",
    name: "AllRetainersWalletTransactions",
    component: AllRetainersWalletTransactions,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },

  {
    path: "/Company/dealer-details",
    name: "dealer_details",
    component: DealerDetails,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/mail-receipt",
    name: "mail_receipt",
    component: MailReceipt,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/tanks-filled",
    name: "tanks_filled",
    component: TanksFilled,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/transaction-count",
    name: "transaction_count",
    component: TransactionCount,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/products-filled",
    name: "products_filled",
    component: ProductFills,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/products-received",
    name: "products_received",
    component: ProductReceived,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/outstanding-payments",
    name: "company_outstanding_payments",
    component: CompanyOutstandingPaymentsList,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/Loyalty",
    name: "company_loyalty",
    component: Loyalty,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },

  {
    path: "/Company/loyalty-details",
    name: "loyalty-details",
    component: LoyaltyDetails,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/Branches/expense-breakdown",
    name: "company_branc_expense_breakdown",
    component: CompanyBranchesExpenseBreakdown,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/make-payments",
    name: "company_make_payments",
    component: CompanyOutstandingPayments,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/wallet-transactions",
    name: "company_wallet_transactions",
    component: CompanyWalletTransactions,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/POS",
    name: "company_POS",
    component: CompanyPOS,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/cash-flow",
    name: "company_cash_flow",
    component: CompanyCashFlow,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/invoices",
    name: "company_invoice",
    // component: Invoices,
    redirect: { name: "not_found" },
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/invoice-details",
    name: "invoice_details",
    // component: InvoiceDetails,
    redirect: { name: "not_found" },
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/invoice-payments",
    name: "invoice_payments",
    // component: InvoicePayments,
    redirect: { name: "not_found" },
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/monoResponse",
    name: "success-page",
    // component: SuccessPage,
    redirect: { name: "not_found" },
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/users",
    name: "company_users",
    component: CompanyUsers,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/create-user",
    name: "create_user",
    component: CreateUser,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/user-details",
    name: "UserDetails",
    component: UserDetails,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },

  {
    path: "/Company/add-user-to-role",
    name: "add_user_to_role",
    component: AddUserToRole,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/admin-profile",
    name: "companyProfile",
    component: CompanyProfile,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/esales",
    name: "CompanyEsales",
    component: CompanyEsales,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/esales-wallet",
    name: "CompanyEsalesWallet",
    component: CompanyEsalesWallet,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/remis-esales",
    name: "CompanyEsalesRemis",
    component: CompanyEsalesRemis,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/role-management",
    name: "RoleManagement",
    component: RoleManagement,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/Company/map-roles",
    name: "MapRoles",
    component: MapRoles,
    meta: {
      authorize: true,
      authRoles: ["Company", "SupportAdmin", "PartnerAdmin"],
    },
  },
  {
    path: "/dashboard",
    name: "userDashboard",
    component: DashboardIndex,
    meta: {
      authorize: true,
      authRoles: ["Customer"],
    },
  },
  {
    path: "/fuel-balance",
    name: "fuelbalance",
    component: FuelBalance,
    meta: {
      authorize: true,
      authRoles: ["Customer"],
    },
  },
  {
    path: "/fuel-balance/previous-wallet-transaction",
    name: "previious_wallet_transaction",
    component: PreviousWalletTransaction,
    meta: {
      authorize: true,
      authRoles: ["Customer"],
    },
  },
  {
    path: "/Voucher",
    name: "voucher",
    component: Voucher,
    meta: {
      authorize: true,
      authRoles: ["Customer"],
    },
  },
  {
    path: "/vehicle",
    name: "vehicle",
    component: Vehicle,
    meta: {
      authorize: true,
      authRoles: ["Customer"],
    },
  },
  {
    path: "/linked-vehicle",
    name: "linked-vehicle",
    component: LinkedVehicle,
    meta: {
      authorize: true,
      authRoles: ["Customer"],
    },
  },
  {
    path: "/create-vehicle",
    name: "create_vehicle",
    component: Create_vehicle,
    meta: {
      authorize: true,
      authRoles: ["Customer"],
    },
  },
  {
    path: "/card-information",
    name: "card_information",
    component: CardInformation,
    meta: {
      authorize: true,
      authRoles: ["Customer"],
    },
  },
  {
    path: "/fund-card",
    name: "fund_card",
    component: FundCard,
    meta: {
      authorize: true,
      authRoles: ["Customer"],
    },
  },
  {
    path: "/extended-report",
    name: "extended_report",
    component: ExtendedReport,
    meta: {
      authorize: true,
      authRoles: ["Customer"],
    },
  },
  {
    path: "/verify-receipt",
    name: "verify_receipt",
    component: VerifyReceipt,
    meta: {
      authorize: true,
      authRoles: ["Customer"],
    },
  },
  {
    path: "/drivers",
    name: "drivers",
    component: Driver,
    meta: {
      authorize: true,
      authRoles: ["Customer"],
    },
  },
  {
    path: "/fuel-consumption",
    name: "fuel_consumption",
    component: FuelConsumption,
    meta: {
      authorize: true,
      authRoles: ["Customer"],
    },
  },
  {
    path: "/vehicle/cards",
    name: "vehicleCards",
    component: VehicleCards,
    meta: {
      authorize: true,
      authRoles: ["Customer"],
    },
  },
  {
    path: "/vehicle-fuel-consumption",
    name: "vehicle_fuel_consumption",
    component: VehicleFuelConsumption,
    meta: {
      authorize: true,
      authRoles: ["Customer"],
    },
  },

  {
    path: "/retainership",
    name: "retainership",
    component: Retainership,
    meta: {
      authorize: true,
      authRoles: ["Customer"],
    },
  },
  {
    path: "/quick-fuel",
    name: "quick_fuel",
    component: QuickFuel,
    meta: {
      authorize: true,
      authRoles: ["Customer"],
    },
  },
  {
    path: "/create-voucher",
    name: "create_Voucher",
    component: CreateVoucher,
    meta: {
      authorize: true,
      authRoles: ["Customer"],
    },
  },
  {
    path: "/send-voucher",
    name: "send_voucher",
    component: SendVoucher,
    meta: {
      authorize: true,
      authRoles: ["Customer"],
    },
  },
  {
    path: "/send-confirmed-voucher",
    name: "send_confirmed_voucher",
    component: SendConfirmedVouchers,
    meta: {
      authorize: true,
      authRoles: ["Customer"],
    },
  },

  {
    path: "/sub-accounts",
    name: "sub_accounts",
    component: SubAccounts,
    meta: {
      authorize: true,
      authRoles: ["Customer"],
    },
  },
  {
    path: "/create-sub-account",
    name: "create_sub_account",
    component: Create_sub_account,
    meta: {
      authorize: true,
      authRoles: ["Customer"],
    },
  },
  {
    path: "/sub-account-details",
    name: "sub_account_details",
    component: Sub_account_details,
    meta: {
      authorize: true,
      authRoles: ["Customer"],
    },
  },
  {
    path: "/fund-wallet",
    name: "fund_wallet",
    component: FundWallet,
    meta: {
      authorize: true,
      authRoles: ["Customer"],
    },
  },
  {
    path: "/driver/vehicles",
    name: "drivers_vehicles",
    component: DriversVehicles,
    meta: {
      authorize: true,
      authRoles: ["Customer"],
    },
  },
  {
    path: "/outstanding-payments",
    name: "outstanding_payments",
    component: OutstandingPaymentsList,
    meta: {
      authorize: true,
      authRoles: ["Customer"],
    },
  },
  {
    path: "/make-payments",
    name: "make_payments",
    component: OutstandingPayments,
    meta: {
      authorize: true,
      authRoles: ["Customer"],
    },
  },
  {
    path: "/wallet-transactions",
    name: "wallet_transactions",
    component: WalletTransactions,
    meta: {
      authorize: true,
      authRoles: ["Customer"],
    },
  },
  {
    path: "/remis-cards",
    name: "cards",
    component: Cards,
    meta: {
      authorize: true,
      authRoles: ["Customer"],
    },
  },
  {
    path: "/profile",
    name: "customer_profile",
    component: Profile,
    meta: {
      authorize: true,
      authRoles: ["Customer"],
    },
  },
  {
    path: "/",
    name: "login",
    component: Login,
    meta: {
      guest: true,
    },
  },
  {
    path: "/rating",
    name: "AddRating",
    component: AddRating,
  },
  {
    path: "/Account/Resolver",
    name: "resolver",
    component: Resolver,
    meta: {
      guest: true,
    },
  },
  {
    path: "/Account/register",
    name: "RegistrationCompleted",
    component: RegistrationCompleted,
    meta: {
      guest: true,
    },
  },
  {
    path: "/Account/confirmEmail",
    name: "Account_confrimation_login",
    component: Account_confrimation_login,
    meta: {
      guest: true,
    },
  },
  {
    path: "/Account/reset-password-request",
    name: "reset_password",
    component: ResetPassword,
    meta: {
      guest: true,
    },
  },
  {
    path: "/Account/signup",
    name: "signup",
    component: Signup,
    meta: {
      guest: true,
    },
  },

  {
    path: "/Account/ResetPassword",
    name: "password_reset_confirmation",
    component: PasswordResetConfirmation,
    meta: {
      guest: true,
    },
  },
  {
    path: "/Account/password/reset",
    name: "password_email_notification",
    component: PasswordEmailNotification,
    meta: {
      guest: true,
    },
  },
  {
    path: "*",
    name: "redirect",
    component: Login,
    meta: {
      guest: true,
    },
  },
  {
    path: "/payment-confirmation",
    name: "payment_confirmation",
    component: PaymentConfirmationComponent,
    meta: {
      guest: true,
    },
  },
  {
    path: "/Account/No-Access",
    name: "noAccess",
    component: NoAccess,
    meta: {
      authorize: true,
      authRoles: [],
    },
  },
  // Pos Owner
  {
    path: "/pos-owner-transactions",
    name: "pos-owner-transactions",
    component: PosOwnerTransactions,
    meta: {
      authorize: true,
      authRoles: ["POS Owner"],
    },
  },
  {
    path: "/pos-owner-terminals",
    name: "pos-owner-terminals",
    component: PosOwnerTerminals,
    meta: {
      authorize: true,
      authRoles: ["POS Owner"],
    },
  },
  {
    path: "/owner-terminal-transactions",
    name: "owner-terminal-transactions",
    component: OwnerTerminalTransactions,
    meta: {
      authorize: true,
      authRoles: ["POS Owner"],
    },
  },
  {
    path: "/owner-transaction-details",
    name: "owner-transaction-details",
    component: OwnerTransactionDetails,
    meta: {
      authorize: true,
      authRoles: ["POS Owner"],
    },
  },

  // Pos Bank
  {
    path: "/pos-bank-transactions",
    name: "pos-bank-transactions",
    component: PosBankTransactions,
    meta: {
      authorize: true,
      authRoles: ["POS Bank"],
    },
  },
  {
    path: "/pos-bank-terminals",
    name: "pos-bank-terminals",
    component: PosBankTerminals,
    meta: {
      authorize: true,
      authRoles: ["POS Bank"],
    },
  },
  {
    path: "/bank-terminal-transactions",
    name: "bank-terminal-transactions",
    component: BankTerminalTransactions,
    meta: {
      authorize: true,
      authRoles: ["POS Bank"],
    },
  },
  {
    path: "/bank-transaction-details",
    name: "bank-transaction-details",
    component: PosTransactionDetails,
    meta: {
      authorize: true,
      authRoles: ["POS Bank"],
    },
  },
  // Eror pages
  {
    path: "/forbidden",
    name: "forbidden",
    component: Forbidden,
    meta: {
      authorize: true,
      authRoles: [],
    },
  },
  {
    path: "/404",
    name: "not_found",
    component: NotFound,
  },

  // Support Admin
  {
    path: "/support/Companies",
    name: "supportCompanies",
    component: SupportCompanies,
    meta: {
      authorize: true,
      authRoles: ["SupportAdmin"],
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});
router.beforeEach((to, from, next) => {
  if (to.matched.some((rec) => rec.meta.authorize)) {
    if (localStorage.getItem("userDetails") === null) {
      next({ name: "login", params: { nextUrl: to.fullPath } });
    } else {
      let user = JSON.parse(localStorage.getItem("userDetails"));
      if (!user.roles) {
        if (user.role) {
          user.roles = user.role.split(",");
          localStorage.setItem("userDetails", JSON.stringify(user));
        }
      }

      // Company Admin
      if (to.matched.some((rec) => rec.meta.authRoles.includes("Company"))) {
        if (
          user.roles.includes("Company") ||
          user.roles.includes("SupportAdmin") ||
          user.roles.includes("PartnerAdmin")
        ) {
          next();
        } else if (
          user.roles.includes("Branch") ||
          user.roles.includes("SupportAdmin") ||
          user.roles.includes("Sub Branch Manager") ||
          user.roles.includes("PartnerAdmin")
        ) {
          next({ name: "branchDashboard" });
        } else if (
          user.roles.includes("Customer") ||
          user.roles.includes("Account Manager")
        ) {
          next({ name: "userDashboard" });
        } else if (
          user.roles.includes("IndustryManager") ||
          user.roles.includes("IndustryAdmin")
        ) {
          next({ name: "IndustrialBranchDashboard" });
        }
      }

      // Dealer
      else if (
        to.matched.some((rec) => rec.meta.authRoles.includes("Dealers"))
      ) {
        if (
          user.roles.includes("Dealers") ||
          user.roles.includes("SupportAdmin") ||
          user.roles.includes("PartnerAdmin")
        ) {
          next();
        } else if (
          user.roles.includes("Company") ||
          user.roles.includes("SupportAdmin") ||
          user.roles.includes("PartnerAdmin")
        ) {
          next();
        } else if (
          user.roles.includes("Branch") ||
          user.roles.includes("SupportAdmin") ||
          user.roles.includes("Sub Branch Manager") ||
          user.roles.includes("PartnerAdmin")
        ) {
          next({ name: "branchDashboard" });
        } else if (
          user.roles.includes("Customer") ||
          user.roles.includes("Account Manager")
        ) {
          next({ name: "userDashboard" });
        } else if (
          user.roles.includes("IndustryManager") ||
          user.roles.includes("IndustryAdmin")
        ) {
          next({ name: "IndustrialBranchDashboard" });
        }
      }
      //Group Management
      else if (
        to.matched.some((rec) => rec.meta.authRoles.includes("SalesRep")) ||
        user.roles.includes("RegionalEngineer") ||
        user.roles.includes("GroupBranchList") ||
        user.roles.includes("Team")
      ) {
        if (
          user.roles.includes("SalesRep") ||
          user.roles.includes("Team") ||
          user.roles.includes("GroupBranchList") ||
          user.roles.includes("RegionalEngineer") ||
          user.roles.includes("SupportAdmin") ||
          user.roles.includes("PartnerAdmin")
        ) {
          next();
        } else if (
          user.roles.includes("Company") ||
          user.roles.includes("SupportAdmin") ||
          user.roles.includes("PartnerAdmin")
        ) {
          next();
        }
      }
      // RegionalManager
      else if (
        to.matched.some((rec) => rec.meta.authRoles.includes("RegionalManager"))
      ) {
        if (
          user.roles.includes("RegionalManager") ||
          user.roles.includes("SupportAdmin") ||
          user.roles.includes("PartnerAdmin")
        ) {
          next();
        } else if (
          user.roles.includes("Company") ||
          user.roles.includes("SupportAdmin") ||
          user.roles.includes("PartnerAdmin")
        ) {
          next();
        } else if (
          user.roles.includes("Branch") ||
          user.roles.includes("SupportAdmin") ||
          user.roles.includes("Sub Branch Manager") ||
          user.roles.includes("PartnerAdmin")
        ) {
          next({ name: "branchDashboard" });
        } else if (
          user.roles.includes("Customer") ||
          user.roles.includes("Account Manager")
        ) {
          next({ name: "userDashboard" });
        } else if (
          user.roles.includes("IndustryManager") ||
          user.roles.includes("IndustryAdmin")
        ) {
          next({ name: "IndustrialBranchDashboard" });
        }
      }

      // Branch
      else if (
        to.matched.some((rec) => rec.meta.authRoles.includes("BranchManager"))
      ) {
        if (
          user.roles.includes("Branch") ||
          user.roles.includes("viewESales") ||
          user.roles.includes("SupportAdmin") ||
          user.roles.includes("Sub Branch Manager") ||
          user.roles.includes("PartnerAdmin")
        ) {
          next();
        } else if (
          user.roles.includes("Company") ||
          user.roles.includes("SupportAdmin") ||
          user.roles.includes("PartnerAdmin")
        ) {
          next();
        } else if (
          user.roles.includes("Dealers") ||
          user.roles.includes("SupportAdmin") ||
          user.roles.includes("PartnerAdmin")
        ) {
          next();
        } else if (
          user.roles.includes("RegionalManager") ||
          user.roles.includes("SupportAdmin") ||
          user.roles.includes("PartnerAdmin")
        ) {
          next();
        } else if (
          user.roles.includes("SalesRep") ||
          user.roles.includes("SupportAdmin") ||
          user.roles.includes("PartnerAdmin")
        ) {
          next();
        } else if (
          user.roles.includes("Customer") ||
          user.roles.includes("Account Manager")
        ) {
          next({ name: "userDashboard" });
        } else if (
          user.roles.includes("IndustryManager") ||
          user.roles.includes("IndustryAdmin")
        ) {
          next({ name: "IndustrialBranchDashboard" });
        }
      }

      // Customer
      else if (
        to.matched.some((rec) => rec.meta.authRoles.includes("Customer"))
      ) {
        if (
          user.roles.includes("Customer") ||
          user.roles.includes("Account Manager")
        ) {
          next();
        } else if (
          user.roles.includes("Company") ||
          user.roles.includes("PartnerAdmin")
        ) {
          next({ name: "companyDashboard" });
        } else if (
          user.roles.includes("Branch") ||
          user.roles.includes("SupportAdmin") ||
          user.roles.includes("Sub Branch Manager") ||
          user.roles.includes("PartnerAdmin")
        ) {
          next({ name: "branchDashboard" });
        } else if (
          user.roles.includes("IndustryManager") ||
          user.roles.includes("IndustryAdmin")
        ) {
          next({ name: "IndustrialBranchDashboard" });
        }
      }

      //  Industrial Manager
      if (
        to.matched.some((rec) => rec.meta.authRoles.includes("IndustryManager"))
      ) {
        if (
          user.roles.includes("IndustryManager") ||
          user.roles.includes("IndustryGroup") ||
          user.roles.includes("IndustryAdmin") ||
          user.roles.includes("PartnerAdmin") ||
          user.roles.includes("SupportAdmin")
        ) {
          next();
        } else if (
          user.roles.includes("Branch") ||
          user.roles.includes("Sub Branch Manager") ||
          user.roles.includes("PartnerAdmin") ||
          user.roles.includes("SupportAdmin")
        ) {
          next({ name: "branchDashboard" });
        } else if (
          user.roles.includes("Customer") ||
          user.roles.includes("Account Manager")
        ) {
          next({ name: "userDashboard" });
        }
      }

      // Pos Owner
      else if (
        to.matched.some((rec) => rec.meta.authRoles.includes("POS Owner"))
      ) {
        if (user.roles.includes("POS Owner")) {
          next();
        }
      }
      // Pos Bank
      else if (
        to.matched.some((rec) => rec.meta.authRoles.includes("POS Bank"))
      ) {
        if (user.roles.includes("POS Bank")) {
          next();
        }
      }
      // Support Admin
      else if (
        to.matched.some(
          (rec) =>
            rec.meta.authRoles.includes("SupportAdmin") ||
            user.roles.includes("PartnerAdmin"),
        )
      ) {
        if (
          user.roles.includes("SupportAdmin") ||
          user.roles.includes("PartnerAdmin")
        ) {
          next();
        }
      }
      //Industry Admin
      else if (
        user.roles.includes("IndustryAdmin") ||
        user.roles.includes("Customer")
      ) {
        next();
      }
      //Industry Group
      else if (
        user.roles.includes("IndustryGroup") ||
        user.roles.includes("Customer")
      ) {
        next();
      } else {
        next();
      }
    }
  } else if (to.matched.some((rec) => rec.meta.guest)) {
    if (localStorage.getItem("userDetails") === null) {
      next();
    } else {
      let user = JSON.parse(localStorage.getItem("userDetails"));
      if (
        user.roles.includes("Company") ||
        user.roles.includes("PartnerAdmin") ||
        user.roles.includes("SupportAdmin")
      ) {
        next({ name: "companyDashboard" });
      } else if (user.roles.includes("POS Owner")) {
        next({ name: "pos-owner-transactions" });
      } else if (user.roles.includes("manualRecords")) {
        next({ name: from.name });
      } else if (user.roles.includes("GroupBranchList")) {
        next({ name: from.name });
      } else if (user.roles.includes("POS Bank")) {
        next({ name: "pos-bank-transactions" });
      } else if (
        user.roles.includes("Branch") ||
        user.roles.includes("Sub Branch Manager") ||
        user.roles.includes("PartnerAdmin") ||
        user.roles.includes("SupportAdmin")
      ) {
        next({ name: "branchDashboard" });
      } else if (
        user.roles.includes("Customer") ||
        user.roles.includes("Account Manager")
      ) {
        next({ name: "userDashboard" });
      } else if (
        user.roles.includes("IndustryManager") ||
        user.roles.includes("IndustryAdmin")
      ) {
        next({ name: "IndustrialBranchDashboard" });
      } else if (
        user.roles.includes("SupportAdmin") ||
        user.roles.includes("SupportAdmin")
      ) {
        next({ name: "supportCompanies" });
      }
    }
  } else {
    // Free pages are handled here
    next();
  }
});

export default router;
